import PropTypes from 'prop-types';
import { Modal as Modal$1, ModalOverlay, ModalContent, Box, ModalCloseButton, keyframes, theme as theme$2, Button as Button$2, Drawer as Drawer$1, DrawerOverlay, DrawerContent, DrawerHeader, DrawerCloseButton, Alert as Alert$1, Icon, VStack, AlertTitle, AlertDescription, Flex, forwardRef as forwardRef$1, Tabs as Tabs$1, FormControl as FormControl$2, FormLabel, Text as Text$1, FormHelperText, FormErrorMessage, Select as Select$2, Switch as Switch$1, Grid as Grid$1, GridItem as GridItem$1, List as List$1, Spinner as Spinner$1, Heading as Heading$1, Container as Container$1, createMultiStyleConfigHelpers, extendTheme, ChakraProvider, Img, Image as Image$1, CircularProgress, Progress as Progress$1, Checkbox as Checkbox$1, Input as Input$2, InputGroup, InputLeftElement, InputRightElement, useTheme, Radio as Radio$1, RadioGroup as RadioGroup$1, Stack, usePrefersReducedMotion, Divider as Divider$1, Textarea as Textarea$1, Popover as Popover$1, PopoverArrow as PopoverArrow$1, PopoverCloseButton as PopoverCloseButton$1, PopoverContent as PopoverContent$1, PopoverHeader, PopoverBody, ButtonGroup, Menu as Menu$1 } from '@chakra-ui/react';
export { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, AspectRatio, Badge, Input as BasicInput, Textarea as BasicTextarea, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, ButtonGroup, Center, CheckboxGroup, Circle, Code, Collapse, DrawerBody, DrawerCloseButton, Drawer as DrawerContainer, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Fade, Flex, HStack, Icon, InputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, Kbd, Link, LinkBox, LinkOverlay, ListItem, MenuButton, MenuDivider, MenuGroup, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, ModalBody, ModalFooter, ModalHeader, PopoverAnchor, PopoverTrigger, Portal, ScaleFade, SimpleGrid, Skeleton, SkeletonCircle, SkeletonText, Slide, SlideFade, Square, Tab, TabList, TabPanel, TabPanels, Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tooltip, Tr, VStack, createIcon, keyframes, useBreakpointValue, useClipboard, useControllableProp, useControllableState, useDisclosure, useMediaQuery, usePopper, usePrefersReducedMotion, useStyleConfig, useTheme, useToast, useToken } from '@chakra-ui/react';
import * as React from 'react';
import React__default, { forwardRef, useState, useEffect, Children, cloneElement } from 'react';
import merge from 'lodash/merge';
import { Global } from '@emotion/react';
import { accordionAnatomy, selectAnatomy } from '@chakra-ui/anatomy';
import template from 'lodash/template';
import cn from 'classnames';
import AsyncSelect from 'react-select/async';
import { motion } from 'framer-motion';
import Creatable from 'react-select/creatable';
import { components as components$1 } from 'react-select';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var header$1 = _ref => {
  let {
    hideCloseButton,
    hasHeader
  } = _ref;
  return {
    padding: !hideCloseButton || hasHeader ? 4 : 2,
    fontSize: 'xl',
    fontWeight: 'semibold',
    // If just close button, still have 'header' section at top
    minHeight: hasHeader || hideCloseButton ? null : 12
  };
};

/**
 * @param {boolean} isMobile - Whether or not the Modal is opened in a mobile viewport
 * @param {boolean} isOpen - Whether or not the Modal is open
 * @param {React.ReactNode} children - The header text of the modal
 * @param {()=>void} [onClose] - Callback invoked to close the Modal. Not required, but strongly suggested.
 * @param {('sm'|'md'|'lg')} [size] - The size of the modal. If unspecified, uses "md" styles.
 * @param {object} [contentStyling] - Style props to be passed into the modal content
 * @param {object} [overlayProps] - Props to be passed into the ModalOverlay component. See: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/modal/src/modal-overlay.tsx
 * @param {boolean} [hasHeader] - Whether or not ModalHeader is a child. Will change the styling
 * @param {boolean} [hasFooter] - Whether or not ModalFooter is a child. Will change the styling
 * @param {React.ReactNode} [hideCloseButton] - Whether or not to show the close button
 * @returns {React.ReactElement} - The Modal component
 */
const Modal = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    hideCloseButton,
    hasHeader,
    isMobile = false,
    contentStyling = {},
    overlayProps = {}
  } = props;
  return /*#__PURE__*/React__default.createElement(Modal$1, _extends$6({
    motionPreset: isMobile ? 'slideInBottom' : 'scale'
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(ModalOverlay, overlayProps), /*#__PURE__*/React__default.createElement(ModalContent, _extends$6({
    "data-testid": "ModalContent"
  }, contentStyling), !hasHeader ? /*#__PURE__*/React__default.createElement(Box, header$1(props)) : null, hideCloseButton ? null : /*#__PURE__*/React__default.createElement(ModalCloseButton, {
    "data-testid": "ModalClose-button"
  }), children));
});
Modal.propTypes = {
  /** Whether or not the Modal is opened in a mobile viewport */
  isMobile: PropTypes.bool,
  /** Whether or not the Modal is open */
  isOpen: PropTypes.bool.isRequired,
  /** React children. Body of the Modal. */
  children: PropTypes.node.isRequired,
  /** Whether or not ModalHeader is a child. Will change the styling */
  hasHeader: PropTypes.bool.isRequired,
  /** Whether or not ModalFooter is a child. Will change the styling */
  hasFooter: PropTypes.bool.isRequired,
  /** Callback invoked to close the Modal. Not required, but strongly suggested. */
  onClose: PropTypes.func,
  /** The size of the modal. If unspecified, uses md styles. */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Whether or not to show the close button (optional) */
  hideCloseButton: PropTypes.bool,
  /** Objects containing css-in-js styling*/
  contentStyling: PropTypes.object,
  /** Objects containing props to apply to ModalOverlay component */
  overlayProps: PropTypes.object
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
const fadeIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     0% { opacity: 0%; }\n     100% { opacity: 100%; }\n\n"])));
const fadeOut = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    0% { opacity: 100%; }\n    100% { opacity: 0% }\n"])));
const fadeInAndEnlarge = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n     0% { opacity: 0%; transform: scale(0.9);}\n     100% { opacity: 100%; transform: scale(1);}\n"])));
const fadeOutAndShrink = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    0% { opacity: 100%; transform: scale(1); }\n    100% { opacity: 0%; transform: scale(0.9); }\n"])));
const fadeInAndSlideUp = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n     0% { opacity: 0%; transform: translateY(2rem) scale(1);}\n     100% { opacity: 100%; transform: translateY(0) scale(1);}\n"])));
const fadeOutAndSlideDown = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    0% { opacity: 100%; transform: translateY(0) scale(1); }\n    100% { opacity: 0%; transform: translateY(2rem) scale(1); }\n"])));

// This is a modified version of our Modal that will always be mounted, even when it is closed.
// We need this for things like Stripe where payment Elements need to be mounted to get a token on checkout
/**
 * @param {boolean} isMobile - Whether or not the Modal is opened in a mobile viewport
 * @param {boolean} isOpen - Whether or not the Modal is open
 * @param {React.ReactNode} children - The header text of the modal
 * @param {()=>void} [onClose] - Callback invoked to close the Modal. Not required, but strongly suggested.
 * @param {('sm'|'md'|'lg')} [size] - The size of the modal. If unspecified, uses "md" styles.
 * @param {object} [contentStyling] - Style props to be passed into the modal content
 * @param {object} [overlayProps] - Props to be passed into the ModalOverlay component. See: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/modal/src/modal-overlay.tsx
 * @param {boolean} [hasHeader] - Whether or not ModalHeader is a child. Will change the styling
 * @param {boolean} [hasFooter] - Whether or not ModalFooter is a child. Will change the styling
 * @param {React.ReactNode} [hideCloseButton] - Whether or not to show the close button
 * @returns {React.ReactElement} - The Modal component
 */
const AlwaysMountedModal = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    hideCloseButton,
    onCloseComplete,
    hasHeader,
    isOpen,
    isMobile = false,
    contentStyling = {},
    overlayProps = {}
  } = props;
  const [internalOpen, setInternalOpen] = useState(isOpen);
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setInternalOpen(false);
        onCloseComplete();
        // Want this to be a bit shorter than fade out animation
      }, 175);
    } else {
      setInternalOpen(true);
    }
  }, [isOpen]);
  const fadeInAnimation = isMobile ? fadeInAndSlideUp : fadeInAndEnlarge;
  const fadeOutAnimation = isMobile ? fadeOutAndSlideDown : fadeOutAndShrink;
  return /*#__PURE__*/React__default.createElement(Modal$1, _extends$6({
    motionPreset: isMobile ? 'slideInBottom' : 'scale'
  }, props, {
    blockScrollOnMount: isOpen,
    isOpen: true,
    ref: ref
  }), /*#__PURE__*/React__default.createElement(Box, {
    visibility: internalOpen ? 'visible' : 'hidden',
    animation: "".concat(isOpen ? fadeIn : fadeOut, " 0.2s ease-in-out"),
    zIndex: 3,
    as: motion.div,
    position: "relative"
  }, /*#__PURE__*/React__default.createElement(ModalOverlay, overlayProps)), /*#__PURE__*/React__default.createElement(Box, {
    visibility: internalOpen ? 'visible' : 'hidden',
    animation: "".concat(isOpen ? fadeIn : fadeOut, " 0.2s ease-in-out"),
    zIndex: 4,
    as: motion.div,
    position: "relative"
  }, /*#__PURE__*/React__default.createElement(ModalContent, _extends$6({}, contentStyling, {
    animation: "".concat(isOpen ? fadeInAnimation : fadeOutAnimation, " 0.2s ease-in-out")
  }), !hasHeader ? /*#__PURE__*/React__default.createElement(Box, header$1(props)) : null, hideCloseButton ? null : /*#__PURE__*/React__default.createElement(ModalCloseButton, null), children)));
});
AlwaysMountedModal.propTypes = {
  /** Whether or not the Modal is opened in a mobile viewport */
  isMobile: PropTypes.bool,
  /** Whether or not the Modal is open */
  isOpen: PropTypes.bool.isRequired,
  /** React children. Body of the Modal. */
  children: PropTypes.node.isRequired,
  /** Whether or not ModalHeader is a child. Will change the styling */
  hasHeader: PropTypes.bool.isRequired,
  /** Whether or not ModalFooter is a child. Will change the styling */
  hasFooter: PropTypes.bool.isRequired,
  /** Callback invoked to close the Modal. Not required, but strongly suggested. */
  onClose: PropTypes.func,
  /** The size of the modal. If unspecified, uses md styles. */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Whether or not to show the close button (optional) */
  hideCloseButton: PropTypes.bool,
  /** Objects containing css-in-js styling*/
  contentStyling: PropTypes.object,
  /** Objects containing props to apply to ModalOverlay component */
  overlayProps: PropTypes.object
};

const container = {
  base: '100%',
  // 640px
  tablet: '45rem',
  // 720px
  desktop: '72rem' // 1152px
};
const sizes$6 = {
  container,
  0: '0',
  0.5: '0.125rem',
  // 2px
  1: '0.25rem',
  // 4px
  1.5: '0.375rem',
  // 6px
  2: '0.5rem',
  // 8px
  2.5: '0.625rem',
  // 10px
  3: '0.75rem',
  // 12px
  3.5: '0.875rem',
  // 14px
  4: '1rem',
  // 16px
  4.5: '1.125rem',
  // 18px
  5: '1.25rem',
  // 20px
  5.5: '1.375rem',
  // 22px
  6: '1.5rem',
  // 24px
  7: '1.75rem',
  // 28px
  8: '2rem',
  // 32px
  9: '2.25rem',
  // 36px
  10: '2.5rem',
  // 40px
  12: '3rem',
  // 48px
  14: '3.5rem',
  // 56px
  16: '4rem',
  // 64px
  20: '5rem',
  // 80px
  24: '6rem',
  // 96px
  28: '7rem',
  // 112px
  32: '8rem',
  // 128px
  36: '9rem',
  // 144px
  40: '10rem',
  // 160px
  44: '11rem',
  // 176px
  48: '12rem',
  // 192px
  52: '13rem',
  // 208px
  56: '14rem',
  // 224px
  60: '15rem',
  // 240px
  64: '16rem',
  // 256px
  72: '18rem',
  // 272px
  80: '20rem',
  // 288px
  96: '24rem',
  // 384px
  px: '1px',
  full: '100%',
  max: 'max-content',
  min: 'min-content'
};

const white = '#ffffff';
const black = '#000000';
const brandBlue = '#0082ff';
const modalOverlay = '#21212160';
const gray = {
  50: '#f6f7f9',
  100: '#e1e6ec',
  200: '#cbd4de',
  300: '#afbdcc',
  400: '#94a7ba',
  500: '#7890a8',
  600: '#537495',
  700: '#3b5261',
  800: '#2f3f4b',
  900: '#26323c'
};
const blue = {
  50: '#f1fcff',
  100: '#e6f8fd',
  200: '#c0e9fb',
  300: '#96d3fa',
  400: '#5baafa',
  500: '#1271eb',
  600: '#1d58f2',
  700: '#1b46da',
  800: '#1735a6',
  900: '#132b7f'
};
const navy = {
  50: '#f4fafc',
  100: '#e4f7fb',
  200: '#bfebf6',
  300: '#92d9f4',
  400: '#51b7f0',
  500: '#2590ea',
  600: '#1a6cda',
  700: '#1b55b6',
  800: '#194185',
  900: '#002d5b'
};
const green = {
  50: '#e9fbf9',
  100: '#d3f7ef',
  200: '#a4f3d9',
  300: '#65eabf',
  400: '#1edb96',
  500: '#09c66a',
  600: '#08ad50',
  700: '#008547',
  800: '#11703e',
  900: '#115a35'
};
const yellow = {
  50: '#fff9e5',
  100: '#faf0bd',
  200: '#f6e67c',
  300: '#f1d439',
  400: '#ffbf02',
  500: '#e19706',
  600: '#cf7404',
  700: '#ae5708',
  800: '#8e440e',
  900: '#743710'
};
const red = {
  50: '#fff3f0',
  100: '#fdeef3',
  200: '#fbcee6',
  300: '#fba4d1',
  400: '#fc6bad',
  500: '#fc4086',
  600: '#f7265f',
  700: '#e01438',
  800: '#b4193c',
  900: '#901530'
};
const colors = {
  gray: _objectSpread2(_objectSpread2({}, gray), {}, {
    light: gray['50'],
    medium: gray['200'],
    dark: gray['600']
  }),
  blue,
  navy,
  red: _objectSpread2(_objectSpread2({}, red), {}, {
    default: red['700']
  }),
  green: _objectSpread2(_objectSpread2({}, green), {}, {
    default: green['700']
  }),
  yellow: _objectSpread2(_objectSpread2({}, yellow), {}, {
    default: yellow['400']
  }),
  primary: _objectSpread2(_objectSpread2({}, blue), {}, {
    default: blue['500']
  }),
  secondary: _objectSpread2(_objectSpread2({}, navy), {}, {
    default: navy['900']
  }),
  success: green['700'],
  warning: yellow['400'],
  error: red['700'],
  accent: gray['200'],
  text: {
    primary: {
      light: black,
      dark: white
    },
    secondary: {
      light: gray['600']
    },
    link: {
      light: blue['500'],
      dark: white
    }
  },
  background: {
    gray: gray['50'],
    white
  },
  white,
  black,
  brandBlue,
  modalOverlay
};

const shadows = {
  outline: '0 0 0 3px rgba(29, 88, 242, 0.7)',
  // primary.600, 70% opacity
  drawer: '-8px 0 16px 0 rgba(33,33,33,.1)'
};
var shadows$1 = merge(theme$2.shadows, shadows);

const indices = {
  hide: -100,
  // equivalent to $z-index-negative in fe-core (https://github.com/spothero/fe-core/blob/main/utils/_defaults.scss)
  auto: 'auto',
  base: 0,
  // equivalent to $z-index-back in fe-core
  layer1: 100,
  // equivalent to $z-index-mid in fe-core
  layer2: 200,
  // equivalent to $z-index-fore in fe-core
  layer3: 300,
  // equivalent to $z-index-layer1 in fe-core
  layer4: 400,
  // equivalent to $z-index-layer2 in fe-core
  layer5: 500,
  // equivalent to $z-index-layer3 in fe-core
  layer6: 600,
  // equivalent to $z-index-layer4 in fe-core
  layer7: 700,
  // equivalent to $z-index-modal-shim in fe-core
  layer8: 800,
  // equivalent to $z-index-modal in fe-core
  layer9: 900,
  // equivalent to $z-index-notification in fe-core
  layer10: 1000 // equivalent to $z-index-top in fe-core
};

const breakpoints = {
  mobileXL: '30rem',
  // 480px
  tablet: '48rem',
  // 768px
  desktop: '64rem',
  // 1024px
  desktopXL: '90rem' // 1440px
};

const fonts = {
  heading: "\"Plus Jakarta Sans\", sans-serif",
  body: "\"Plus Jakarta Sans\", sans-serif"
};
const fontSizes = {
  '5xl': '3.5rem',
  // 56px
  '4xl': '3rem',
  // 48px
  '3xl': '2.5rem',
  // 40px
  '2xl': '2rem',
  // 32px
  xl: '1.5rem',
  // 24px
  lg: '1.25rem',
  // 20px
  md: '1.125rem',
  // 18px
  base: '1rem',
  // 16px
  sm: '0.875rem',
  // 14px
  xs: '0.75rem' // 12px
};
const fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

const NOTIFICATION_STATUSES = {
  NEUTRAL: 'neutral',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success'
};
const NOTIFICATION_SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
const notificationBaseStyle = {
  container: {
    paddingY: 2,
    borderRadius: 'base'
  },
  actionButton: {
    fontSize: 'sm',
    height: 'fit-content',
    lineHeight: '1.4',
    color: 'primary.600',
    _hover: {
      color: 'primary.700'
    }
  },
  dismissButton: {
    color: 'gray.600',
    borderColor: 'transparent',
    borderWidth: '2px',
    padding: 0,
    width: 10,
    height: 10,
    backgroundColor: 'transparent',
    borderRadius: 'base',
    marginLeft: 2,
    _hover: {
      color: 'gray.700'
    },
    _focus: {
      color: 'gray.700',
      borderColor: 'white',
      boxShadow: 'outline'
    }
  },
  icon: {
    width: 6,
    marginRight: 2,
    height: 'auto'
  },
  description: {
    lineHeight: 1.4
  },
  title: {
    lineHeight: 1.4
  },
  variants: {},
  sizes: {
    sm: {
      title: {
        fontSize: 'xs'
      },
      description: {
        fontSize: 'xs'
      }
    },
    md: {
      title: {
        fontSize: 'sm'
      },
      description: {
        fontSize: 'sm'
      }
    },
    lg: {
      title: {
        fontSize: 'base'
      },
      description: {
        fontSize: 'base'
      }
    }
  }
};
const notificationStatusStyles = status => {
  switch (status) {
    case NOTIFICATION_STATUSES.NEUTRAL:
      return {
        container: {
          background: 'blue.50'
        },
        icon: {
          color: 'blue.500'
        },
        dismissButton: {
          _hover: {
            background: 'blue.200'
          },
          _focus: {
            background: 'blue.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.WARNING:
      return {
        container: {
          background: 'yellow.50'
        },
        icon: {
          color: 'yellow.400'
        },
        dismissButton: {
          _hover: {
            background: 'yellow.200'
          },
          _focus: {
            background: 'yellow.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.ERROR:
      return {
        container: {
          background: 'red.50'
        },
        icon: {
          color: 'red.700'
        },
        dismissButton: {
          _hover: {
            background: 'red.200'
          },
          _focus: {
            background: 'red.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.SUCCESS:
      return {
        container: {
          background: 'green.50'
        },
        icon: {
          color: 'green.700'
        },
        dismissButton: {
          _hover: {
            background: 'green.200'
          },
          _focus: {
            background: 'green.200'
          }
        }
      };
    default:
      return {};
  }
};
const notificationSizeStyles = size => {
  switch (size) {
    case NOTIFICATION_SIZES.SM:
      return {
        title: {
          fontSize: 'xs'
        },
        description: {
          fontSize: 'xs'
        }
      };
    case NOTIFICATION_SIZES.MD:
      return {
        title: {
          fontSize: 'sm'
        },
        description: {
          fontSize: 'sm'
        }
      };
    case NOTIFICATION_SIZES.LG:
      return {
        title: {
          fontSize: 'base'
        },
        description: {
          fontSize: 'base'
        }
      };
    default:
      return {};
  }
};

var base = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NOTIFICATION_STATUSES: NOTIFICATION_STATUSES,
  breakpoints: breakpoints,
  colors: colors,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  fonts: fonts,
  notificationBaseStyle: notificationBaseStyle,
  notificationStatusStyles: notificationStatusStyles,
  shadows: shadows$1,
  sizes: sizes$6,
  zIndices: indices
});

const baseStyle$f = {
  px: 8,
  py: 3,
  fontSize: 'base',
  fontFamily: 'body',
  lineHeight: 0.875,
  fontWeight: 'semibold',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '1.25rem',
  textTransform: 'capitalize',
  transition: 'all normal ease',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 1,
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  },
  '& svg': {
    display: 'block'
  }
};
// TODO: We need an active styling
const disabledButtonHoverStyle = {
  _disabled: {
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  }
};
const destructiveButtonStyles = {
  bg: 'white',
  borderColor: 'red.default',
  color: 'red.default',
  _hover: _objectSpread2({
    borderColor: 'red.800',
    color: 'red.800'
  }, disabledButtonHoverStyle)
};
const variants$d = {
  primary: {
    bg: 'primary.default',
    borderColor: 'primary.default',
    color: 'white',
    _hover: _objectSpread2({
      bg: 'primary.600',
      borderColor: 'primary.600',
      color: 'white'
    }, disabledButtonHoverStyle)
  },
  primaryOnDark: {
    bg: 'yellow.default',
    borderColor: 'yellow.default',
    color: 'black',
    _hover: _objectSpread2({
      bg: 'yellow.500',
      borderColor: 'yellow.500',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  secondary: {
    bg: 'white',
    borderColor: 'gray.medium',
    color: 'primary.default',
    _hover: _objectSpread2({
      borderColor: 'primary.600',
      color: 'primary.600'
    }, disabledButtonHoverStyle)
  },
  secondaryOnDark: {
    bg: 'none',
    borderColor: 'white',
    color: 'white',
    _hover: _objectSpread2({
      bg: 'white',
      borderColor: 'white',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  tertiary: {
    bg: 'none',
    borderWidth: 'none',
    borderRadius: 'unset',
    color: 'primary.default',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    lineHeight: 1,
    _disabled: {
      bg: 'none',
      color: 'gray.dark'
    },
    _hover: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    },
    _active: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    }
  },
  tertiaryOnDark: {
    bg: 'none',
    borderRadius: 'unset',
    borderWidth: 'none',
    color: 'white',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    _disabled: {
      bg: 'none',
      color: 'white',
      opacity: '.7'
    },
    _hover: {
      color: 'white',
      opacity: '.8',
      _disabled: {
        opacity: '.7'
      }
    }
  },
  destructive: _objectSpread2({}, destructiveButtonStyles),
  destructiveOnDark: _objectSpread2({}, destructiveButtonStyles)
};
const defaultProps$a = {
  size: null
};
var buttonStyles = merge(theme$2.components.Button, {
  variants: variants$d,
  baseStyle: baseStyle$f,
  defaultProps: defaultProps$a
});

const props = {
  /**
   * Alters the underlying html tag
   */
  as: PropTypes.string,
  /**
   * If `true`, the button will render as an anchor.
   */
  asAnchor: PropTypes.bool,
  /**
   * If `true`, and an anchor button, target="_blank" and rel="noopener noreferrer" will be set on the anchor
   * "isExternal" is used to maintain parity with the Link component.
   */
  isExternal: PropTypes.bool,
  /**
   * If `true`, the button will show a spinner.
   */
  isLoading: PropTypes.bool,
  /**
   * If `true`, the button will be styled in its active state.
   */
  isActive: PropTypes.bool,
  /**
   * If `true`, the button will be disabled.
   */
  isDisabled: PropTypes.bool,
  /**
   * The label to show in the button when `isLoading` is true
   * If no text is passed, it only shows the spinner
   */
  loadingText: PropTypes.string,
  /**
   * The html button type to use.
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /**
   * If added, the button will show an icon before the button's label.
   * @type PropTypes.node
   */
  leftIcon: PropTypes.node,
  /**
   * If added, the button will show an icon after the button's label.
   * @type PropTypes.node
   */
  rightIcon: PropTypes.node,
  /**
   * The space between the button icon and label.
   * @type SystemProps["marginRight"]
   */
  iconSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Replace the spinner component when `isLoading` is set to `true`
   * @type PropTypes.node
   */
  spinner: PropTypes.node,
  variant: PropTypes.oneOf(Object.keys(variants$d))
};

const _excluded$t = ["asAnchor", "isExternal", "height"];
const anchorProps = function () {
  let isExternal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return _objectSpread2({
    as: 'a',
    type: null
  }, isExternal && {
    target: '_blank',
    rel: 'noopener noreferrer'
  });
};
const heightProps = function () {
  let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'md';
  const heights = {
    md: {},
    lg: {
      height: 12,
      borderRadius: sizes$6['6'],
      lineHeight: sizes$6['6']
    }
  };
  return heights[height] || {
    height // when a custom height is provided, pass it as is
  };
};
const Button$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      asAnchor,
      isExternal,
      height = 'md'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$t);
  return /*#__PURE__*/React__default.createElement(Button$2, _extends$6({
    iconSpacing: 2
  }, props, heightProps(height), (asAnchor || props.as === 'a') && anchorProps(isExternal), {
    ref: ref
  }));
});
Button$1.propTypes = props;
Button$1.defaultProps = {
  variant: 'primary',
  type: 'button'
};

const _excluded$s = ["header", "drawerCloseButton", "children", "headerProps"];
const Drawer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      header,
      drawerCloseButton,
      children,
      headerProps
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$s);
  return /*#__PURE__*/React__default.createElement(Drawer$1, _extends$6({
    placement: "right"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(DrawerOverlay, null), /*#__PURE__*/React__default.createElement(DrawerContent, null, /*#__PURE__*/React__default.createElement(DrawerHeader, headerProps, header, drawerCloseButton || /*#__PURE__*/React__default.createElement(DrawerCloseButton, null)), children));
});
Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

const AccordionActionButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    onClick
  } = _ref;
  const handleOnClick = e => {
    if (onClick) {
      e.preventDefault();
    }
    onClick === null || onClick === void 0 || onClick();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    ref: ref,
    fontSize: "sm",
    role: "button",
    onClick: handleOnClick,
    color: "primary.default"
  }, children);
});
AccordionActionButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired
};

var _path$5;
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
var SvgX = function SvgX(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
  })));
};
var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgX);

var _path$4;
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
var SvgInfoCircleFilled = function SvgInfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
  })));
};
var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgInfoCircleFilled);

var _path$3;
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
var SvgExclamationTriangleFilled = function SvgExclamationTriangleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A1 1 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467zM13 18h-2v-2h2zm-2-4V9h2l.001 5z"
  })));
};
var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgExclamationTriangleFilled);

var _path$2;
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
var SvgCheckmarkCircleFilled = function SvgCheckmarkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414z"
  })));
};
var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgCheckmarkCircleFilled);

const _excluded$r = ["status", "title", "buttonProps", "buttonText", "buttonOnBottom", "showDismiss", "onDismissClick", "showIcon", "description", "icon"];
const statusIconMapping = {
  [NOTIFICATION_STATUSES.WARNING]: ForwardRef$3,
  [NOTIFICATION_STATUSES.SUCCESS]: ForwardRef$2,
  [NOTIFICATION_STATUSES.ERROR]: ForwardRef$3,
  [NOTIFICATION_STATUSES.NEUTRAL]: ForwardRef$4
};
const Alert = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      status,
      title,
      buttonProps,
      buttonText,
      buttonOnBottom,
      showDismiss,
      onDismissClick,
      showIcon,
      description,
      icon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$r);
  const IconVariant = icon || statusIconMapping[status];
  // the issue with storybook breaking with hooks is still a problem, but once that's resolved this should be memoized
  const style = merge(_objectSpread2({}, theme$2.components.Alert.baseStyle), notificationBaseStyle, notificationStatusStyles(status), notificationSizeStyles(props.size));
  return /*#__PURE__*/React__default.createElement(Alert$1, _extends$6({}, style.container, {
    "data-status": status
  }, props, {
    ref: ref
  }), showIcon ? /*#__PURE__*/React__default.createElement(Icon, _extends$6({}, style.icon, {
    as: IconVariant
  })) : null, /*#__PURE__*/React__default.createElement(VStack, {
    spacing: 0,
    alignItems: "flex-start"
  }, title ? /*#__PURE__*/React__default.createElement(AlertTitle, style.title, title) : null, description ? /*#__PURE__*/React__default.createElement(AlertDescription, style.description, description) : null, buttonOnBottom && buttonText && buttonProps ? /*#__PURE__*/React__default.createElement(Button$1, _extends$6({}, style.actionButton, {
    variant: "tertiary"
  }, buttonProps), buttonText) : null), /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    marginLeft: "auto"
  }, !buttonOnBottom && buttonText && buttonProps ? /*#__PURE__*/React__default.createElement(Button$1, _extends$6({}, style.actionButton, {
    variant: "tertiary"
  }, buttonProps), buttonText) : null, showDismiss ? /*#__PURE__*/React__default.createElement(Button$1, _extends$6({}, style.dismissButton, {
    onClick: onDismissClick
  }), /*#__PURE__*/React__default.createElement(Icon, {
    width: 6,
    height: "auto",
    as: ForwardRef$5
  })) : null));
});
Alert.propTypes = {
  /** Status. One of: success, neutral, warning, or error */
  status: PropTypes.oneOf(['neutral', 'success', 'warning', 'error']),
  /** Title Text. Will not display title if empty */
  title: PropTypes.node,
  /** Props to pass to button (like onClick). Will not display button if this or buttonText empty */
  buttonProps: PropTypes.object,
  /** Text of button. Will not display button if this or buttonProps empty */
  buttonText: PropTypes.string,
  /** Whether action button should be under description (as opposed to on right) */
  buttonOnBottom: PropTypes.bool,
  /** Whether or not to show X dismiss button */
  showDismiss: PropTypes.bool,
  /** Callback when X clicked */
  onDismissClick: PropTypes.func,
  /** Whether or not to show the icon */
  showIcon: PropTypes.bool,
  /** Description text. Will not display description if empty */
  description: PropTypes.node,
  /** Size of the text */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Custom Icon */
  icon: PropTypes.func
};
Alert.defaultProps = {
  status: 'neutral',
  title: null,
  buttonProps: null,
  buttonText: null,
  buttonOnBottom: false,
  showDismiss: false,
  onDismissClick: null,
  showIcon: true,
  description: null,
  size: 'md',
  icon: null
};

const variants$c = {
  line: {
    tablist: {
      borderBottom: '2px solid',
      borderColor: 'inherit'
    },
    tab: {
      color: 'gray.600',
      borderBottom: '2px solid',
      borderColor: 'transparent',
      marginBottom: '-2px',
      _selected: {
        color: 'primary.default',
        borderColor: 'primary.default',
        fontWeight: 'semibold'
      },
      _active: {
        color: 'black',
        bg: 'transparent'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _hover: {
        color: 'black'
      }
    }
  },
  enclosed: {
    tablist: {
      backgroundColor: 'white',
      borderRadius: '8px',
      borederColor: 'gray.200',
      borderWidth: '1px',
      paddingY: 1
    },
    tab: {
      borderRadius: '6px',
      marginX: 1,
      _selected: {
        fontWeight: 'semibold',
        color: 'white',
        backgroundColor: 'primary.default',
        _hover: {
          backgroundColor: 'primary.600'
        }
      },
      _active: {
        backgroundColor: 'gray.200'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      }
    }
  }
};
var styles$2 = merge(theme$2.components.Tabs, {
  variants: variants$c
});

const SIZE_SMALL = 'small';
const SIZE_BODY = 'body';
const SIZE_HEADING = 'heading';

/**
 * ### `combineSizeWithVariant`
 * A function that takes in the `size` value, and the
 * `variant` value. The default-like styling for the `size` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * @function combineSizeWithVariant
 * @param {string} args.size - The size of Tabs component
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `size` props
 */

const combineSizeWithVariant = _ref => {
  let {
    size,
    variant = 'line'
  } = _ref;
  const fontSizeMapping = {
    [SIZE_SMALL]: fontSizes.xs,
    [SIZE_BODY]: fontSizes.base,
    [SIZE_HEADING]: fontSizes.lg
  };
  const styleProps = styles$2.variants["".concat(variant)];
  styleProps.tab.fontSize = fontSizeMapping[size];
  return styleProps;
};

const _excluded$q = ["size"];
const sizeMapping = {
  [SIZE_SMALL]: 'sm',
  [SIZE_BODY]: 'md',
  [SIZE_HEADING]: 'lg'
};
const Tabs = forwardRef$1((_ref, ref) => {
  let {
      size
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$q);
  return /*#__PURE__*/React__default.createElement(Tabs$1, _extends$6({
    size: sizeMapping[size]
  }, props, combineSizeWithVariant({
    size
  }), {
    ref: ref
  }));
});
Tabs.defaultProps = {
  size: SIZE_BODY
};
Tabs.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the size of Tabs */
  size: PropTypes.oneOf([SIZE_SMALL, SIZE_BODY, SIZE_HEADING])
};

var _path$1;
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"
  })));
};
var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgChevronDown);

const _excluded$p = ["children", "label", "inputId", "helperText", "errorMessage", "isFieldset", "isOptional", "customRequiredText"];
const FormControl$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      label,
      inputId,
      helperText,
      errorMessage,
      isFieldset,
      isOptional,
      customRequiredText
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React__default.createElement(FormControl$2, _extends$6({}, props, {
    ref: ref,
    as: isFieldset ? 'fieldset' : 'div',
    borderWidth: "0"
  }), label && /*#__PURE__*/React__default.createElement(FormLabel, {
    color: "gray.600",
    fontWeight: "semibold",
    marginBottom: helperText ? 0 : 1,
    fontSize: "sm",
    htmlFor: inputId,
    as: isFieldset ? 'legend' : 'label',
    requiredIndicator: props !== null && props !== void 0 && props.isRequired && customRequiredText ? /*#__PURE__*/React__default.createElement(Text$1, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, customRequiredText) : null,
    optionalIndicator: isOptional && !(props !== null && props !== void 0 && props.isRequired) ? /*#__PURE__*/React__default.createElement(Text$1, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, "Optional") : null
  }, label), helperText && /*#__PURE__*/React__default.createElement(FormHelperText, {
    color: "gray.600",
    marginBottom: 1,
    fontSize: "xs"
  }, helperText), children, /*#__PURE__*/React__default.createElement(FormErrorMessage, {
    color: "error",
    mt: 1,
    fontSize: "xs"
  }, errorMessage));
});
FormControl$1.propTypes = {
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.element,
  isFieldset: PropTypes.bool,
  isOptional: PropTypes.bool,
  isRequired: PropTypes.bool,
  customRequiredText: PropTypes.string
};

const _excluded$o = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional"];
const Select$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      isOptional
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$o);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    isOptional: isOptional,
    helperText: helperText,
    label: label,
    inputId: props.id
  }, /*#__PURE__*/React__default.createElement(Select$2, _extends$6({
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      as: ForwardRef$1
    }),
    iconSize: 12,
    fontWeight: "regular",
    fontSize: "sm",
    ref: ref,
    className: classes
  }, props)));
});
Select$1.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool
};

const _excluded$n = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired"];
const Switch = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$n);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id
  }, /*#__PURE__*/React__default.createElement(Switch$1, _extends$6({
    ref: ref,
    className: classes
  }, props)));
});
Switch.propTypes = {
  isChecked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool
};

const options = ['a', 'abbr', 'address', 'article', 'aside', 'b', 'bdi', 'bdo', 'blockquote', 'button', 'caption', 'cite', 'code', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'fieldset', 'figure', 'footer', 'form', 'header', 'hgroup', 'i', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video'];

const baseStyle$e = {
  lineHeight: 1.5,
  fontWeight: fontWeights.normal
};
const variants$b = {
  body: _objectSpread2(_objectSpread2({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.base
    }
  }),
  body2: _objectSpread2(_objectSpread2({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.sm,
      desktop: fontSizes.sm
    }
  }),
  caption: _objectSpread2(_objectSpread2({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.xs,
      desktop: fontSizes.xs
    }
  })
};
const defaultProps$9 = {
  variant: variants$b.body
};
var Text_styles = merge(theme$2.components.Text, {
  variants: variants$b,
  baseStyle: baseStyle$e,
  defaultProps: defaultProps$9
});

// Create list of commonly used html text elements
const asOptions = Object.freeze({
  bold: 'b',
  strong: 'strong',
  italic: 'i',
  emphasis: 'em',
  small: 'small',
  strikethrough: 's',
  underline: 'u'
});

/**
 * ### `combineAsWithVariant`
 * A function that takes in the `as` value (the HTML element to render the Text component as), and the
 * `variant` value. The default-like styling for the `as` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * By default the `as` property only effects the underlying semantics of the markup, whereas the
 * `variant` only effects the visual styling of the text. In order for the text component to be built
 * with accessibility and ease-of-use in mind, these two properties _should_ be interconnected. Having
 * the style and markup unified allows an experience that is accessible to those using screen-readers
 * (or any other assistive technology) that matches (or is at least a close approximation) of the
 * "standard" visual experience.
 *
 * @function combineAsWithVariant
 * @param {string} args.as - The HTML element to render the Text component as
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `as` props
 */

const combineAsWithVariant = _ref => {
  let {
    as,
    variant
  } = _ref;
  const variantFontSizeBase = Number(variants$b["".concat(variant)].fontSize.base.replace('rem', ''));
  const variantFontSizeDesktop = Number(variants$b["".concat(variant)].fontSize.desktop.replace('rem', ''));
  let styleProps;
  switch (as) {
    case asOptions.bold:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        fontWeight: fontWeights.semibold
      });
      break;
    case asOptions.strong:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        fontWeight: fontWeights.semibold
      });
      break;
    case asOptions.italic:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.emphasis:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.underline:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        textDecoration: 'underline'
      });
      break;
    case asOptions.strikethrough:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        textDecoration: 'line-through'
      });
      break;
    case asOptions.small:
      styleProps = _objectSpread2(_objectSpread2({}, variants$b["".concat(variant)]), {}, {
        fontSize: {
          base: "".concat(variantFontSizeBase * 0.8, "rem"),
          desktop: "".concat(variantFontSizeDesktop * 0.8, "rem")
        }
      });
      break;
    default:
      styleProps = _objectSpread2({}, variants$b["".concat(variant)]);
      break;
  }
  return styleProps;
};

const _excluded$m = ["as", "variant"];
const Text = forwardRef$1((_ref, ref) => {
  let {
      as,
      variant
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$m);
  return /*#__PURE__*/React__default.createElement(Text$1, _extends$6({
    variant: variant,
    as: as
  }, combineAsWithVariant({
    as,
    variant
  }), props, {
    ref: ref
  }));
});
Text.defaultProps = {
  as: 'p',
  variant: 'body'
};
Text.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the underlying styling of the html heading tag */
  as: PropTypes.oneOf(options),
  /** The styling that will be applied to the component regardless of the underlying html */
  variant: PropTypes.oneOf(Object.keys(variants$b))
};

// NOTE: considering adding a specifc prop for grid row padding
const baseStyles = {
  gap: {
    base: 4,
    tablet: 8
  },
  templateColumns: 'repeat(12, 1fr)'
};
const compactStyles = {
  gap: 4
};

const _excluded$l = ["isCompact"];
const Grid = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      isCompact
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$l);
  return /*#__PURE__*/React__default.createElement(Grid$1, _extends$6({}, baseStyles, isCompact && compactStyles, props, {
    ref: ref
  }));
});
Grid.propTypes = {
  /** This will reduce the grid gap by half */
  isCompact: PropTypes.bool
};
Grid.defaultProps = {
  isCompact: false
};

// NOTE: styles NOT in the Chakra's base styles do not need to explicitly export baseStyles
// TODO: move this comment to the readme

const styles$1 = {
  colSpan: 12
};

const GridItem = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(GridItem$1, _extends$6({}, styles$1, props, {
  ref: ref
})));

const _excluded$k = ["type"];
const unorderedProps = {
  as: 'ul',
  styleType: 'disc'
};
const orderedProps = {
  as: 'ol',
  styleType: 'decimal'
};
const STYLE_POSITIONS = {
  unset: 'unset',
  revert: 'revert',
  inside: 'inside',
  outside: 'outside',
  initial: 'initial',
  inherit: 'inherit'
};
const TYPES = {
  ordered: 'ordered',
  unstyled: 'unstyled',
  unordered: 'unordered'
};
const getListProps = type => {
  switch (type) {
    case TYPES.ordered:
      return orderedProps;
    case TYPES.unordered:
      return unorderedProps;
    default:
      return;
  }
};
const List = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      type
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$k);
  return /*#__PURE__*/React__default.createElement(List$1, _extends$6({}, getListProps(type), props, {
    ref: ref
  }));
});
List.defaultProps = {
  type: TYPES.unstyled,
  stylePosition: STYLE_POSITIONS.inside
};
List.propTypes = {
  /** The position of the list style */
  stylePosition: PropTypes.oneOf(Object.keys(STYLE_POSITIONS)),
  /** Changes the underlying markdown to be an ordered or unorderd list, (unstyled will render a ul by default) */
  type: PropTypes.oneOf(Object.keys(TYPES))
};

const spinnerStyles = theme$2.components.Spinner;
const SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl',
  '5xl': '5xl',
  '6xl': '6xl',
  '7xl': '7xl',
  '8xl': '8xl',
  '9xl': '9xl',
  '10xl': '10xl'
};
const sizes$5 = merge(spinnerStyles.sizes, {
  [SIZE_MAP['2xl']]: {
    w: '4rem',
    h: '4rem'
  },
  [SIZE_MAP['3xl']]: {
    w: '5rem',
    h: '5rem'
  },
  [SIZE_MAP['4xl']]: {
    w: '6rem',
    h: '6rem'
  },
  [SIZE_MAP['5xl']]: {
    w: '7rem',
    h: '7rem'
  },
  [SIZE_MAP['6xl']]: {
    w: '8rem',
    h: '8rem'
  },
  [SIZE_MAP['7xl']]: {
    w: '9rem',
    h: '9rem'
  },
  [SIZE_MAP['8xl']]: {
    w: '10rem',
    h: '10rem'
  },
  [SIZE_MAP['9xl']]: {
    w: '11rem',
    h: '11rem'
  },
  [SIZE_MAP['10xl']]: {
    w: '12rem',
    h: '12rem'
  }
});
const thicknesses = {
  [SIZE_MAP.xl]: 3,
  [SIZE_MAP['2xl']]: 4,
  [SIZE_MAP['3xl']]: 5,
  [SIZE_MAP['4xl']]: 6,
  [SIZE_MAP['5xl']]: 7,
  [SIZE_MAP['6xl']]: 8,
  [SIZE_MAP['7xl']]: 9,
  [SIZE_MAP['8xl']]: 10,
  [SIZE_MAP['9xl']]: 11,
  [SIZE_MAP['10xl']]: 12
};
const defaultProps$8 = {
  speed: '2s',
  size: SIZE_MAP['2xl'],
  thickness: thicknesses[SIZE_MAP['2xl']]
};
var Spinner_styles = {
  sizes: sizes$5,
  defaultProps: defaultProps$8
};

const _excluded$j = ["size", "thickness"];
const Spinner = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      size,
      thickness
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$j);
  const thicknessString = thickness ? "".concat(thickness, "px") : thicknesses[size] ? "".concat(thicknesses[size], "px") : '2px';
  return /*#__PURE__*/React__default.createElement(Spinner$1, _extends$6({
    ref: ref,
    role: "status",
    color: "primary.default",
    emptyColor: "gray.medium",
    thickness: thicknessString,
    size: size || SIZE_MAP['2xl']
  }, props));
});
Spinner.propTypes = {
  /** The main fill color of the spinner */
  color: PropTypes.string,
  /** The diameter of the spinner ring in pixels */
  thickness: PropTypes.number,
  /** The empty color of the spinner */
  emptyColor: PropTypes.string,
  /** The size of the spinner */
  size: PropTypes.oneOf(Object.keys(SIZE_MAP)),
  /** The speed of the spinner, ex: 10s, 0.1s, 250ms */
  speed: PropTypes.string
};

const baseStyle$d = {
  lineHeight: 1.5,
  fontWeight: fontWeights.semibold
};
const variants$a = {
  h1: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes['2xl'],
      desktop: fontSizes['3xl']
    }
  }),
  h2: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.xl,
      desktop: fontSizes['2xl']
    }
  }),
  h3: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.lg,
      desktop: fontSizes.xl
    }
  }),
  h4: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.lg
    }
  }),
  h5: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.base
    }
  }),
  h6: _objectSpread2(_objectSpread2({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.sm,
      desktop: fontSizes.sm
    }
  })
};
const defaultProps$7 = {
  variant: variants$a.h2
};
var Heading_styles = {
  variants: variants$a,
  baseStyle: baseStyle$d,
  defaultProps: defaultProps$7
};

const Heading = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(Heading$1, _extends$6({}, props, {
  ref: ref,
  variant: props.variant || props.as || 'h2'
})));
Heading.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the underlying level of the html heading tag */
  as: PropTypes.oneOf(Object.keys(variants$a)),
  /** The styling that will be applied to the component regardless of the underlying html */
  variant: PropTypes.oneOf(Object.keys(variants$a))
};

const styles = {
  px: 4,
  mx: 'auto',
  maxW: {
    base: 'container.base',
    tablet: 'container.tablet',
    desktop: 'container.desktop'
  }
};

const Container = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(Container$1, _extends$6({}, styles, props, {
  ref: ref
})));

const global = {
  'html, body': {
    color: 'text.primary.light'
  },
  // By default, Chakra has all svgs set to 'display: block',
  // this breaks the layout of some older components, so now
  // we set all svgs to 'display: inline-block;' and only set
  // 'display: block;' on the components that need it
  // (as of 3/9/2021 only the v1 AutoSuggestInput component
  // needed this update)
  svg: {
    display: 'inline-block'
  },
  // starting in Chakra version 2 they introduced this isolation style that messes with dropdowns being able to appear on top of elements underneath them
  '.chakra-input__group': {
    isolation: 'auto !important'
  },
  // Starting in Chakra version 2 they have incorporated normalize.css which may resulf in some unexpected default styles
  'h1, h2, h3, h4, h5, h6': {
    margin: 0
  }
};
const Fonts = () => /*#__PURE__*/React__default.createElement(Global, {
  styles: "\n            @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap');\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 700;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 600;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 400;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 300;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n        "
});
const LegacyOverrides = _ref => {
  let {
    useLegacyOverrides
  } = _ref;
  return useLegacyOverrides ? /*#__PURE__*/React__default.createElement(Global, {
    styles: "\n        h1,\n        h2,\n        h3,\n        h4,\n        h5,\n        h6 {\n            margin-top: 0;\n            font-weight: ".concat(fontWeights.semibold, ";\n        }\n\n        .heading-sm {\n            font-size: ").concat(fontSizes.base, ";\n        }\n        .heading-md {\n            font-size: ").concat(fontSizes.md, ";\n        }\n        .heading-lg {\n            font-size: ").concat(fontSizes['5xl'], ";\n        }\n\n        p {\n            line-height: 1.5;\n        }\n\n        a {\n            outline: none;\n            text-align: left;\n            color: ").concat(colors.primary.default, ";\n            text-decoration: none;\n\n            &:active,\n            &:focus {\n                outline: none;\n            }\n\n            &:hover {\n                color: ").concat(colors.primary['700'], ";\n            }\n        }\n\n        small {\n            font-size: ").concat(fontSizes.xs, ";\n        }\n\n        ")
  }) : null;
};
LegacyOverrides.propTypes = {
  /** If true, this will use the old `spothero-html` base styles */
  useLegacyOverrides: PropTypes.bool
};

const item = {
  mb: 2
};

const baseStyle$c = {
  item
};
var index$9 = merge(theme$2.components.List, {
  baseStyle: baseStyle$c
});

const parts$2 = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];
const baseStyle$b = {
  table: {
    borderCollapse: 'collapse',
    color: 'text.primary.light',
    width: '100%'
  },
  thead: {
    borderBottom: '1px',
    borderColor: 'gray.medium'
  },
  th: {
    fontFamily: 'heading',
    fontSize: variants$a.h4.fontSize,
    fontWeight: 'semibold',
    letterSpacing: 'unset',
    padding: 4,
    textAlign: 'start',
    textTransform: 'none'
  },
  tr: {
    borderBottom: '1px',
    borderColor: 'gray.medium',
    _last: {
      border: 'none'
    }
  },
  td: {
    padding: 4,
    textAlign: 'start'
  }
};
const roundedWhiteVariant = {
  table: {
    backgroundColor: 'background.white',
    borderRadius: 6,
    boxShadow: 'md',
    marginBottom: 1
  }
};
const roundedGrayVariant = {
  table: _objectSpread2(_objectSpread2({}, roundedWhiteVariant.table), {}, {
    backgroundColor: 'background.gray'
  })
};
const variants$9 = {
  rounded: roundedWhiteVariant,
  roundedGray: roundedGrayVariant
};
const defaultProps$6 = {
  variant: 'rounded'
};
var Table_styles = {
  parts: parts$2,
  variants: variants$9,
  baseStyle: baseStyle$b,
  defaultProps: defaultProps$6
};

const baseStyle$a = {
  transition: "all 0.15s ease",
  color: 'text.link.light',
  fontWeight: 'semibold',
  _hover: {
    color: 'primary.600',
    textDecoration: 'none'
  },
  _focus: {
    boxShadow: 'outline'
  },
  '& svg': {
    d: 'inline-block',
    verticalAlign: 'initial'
  }
};
const linkOnDark = {
  color: 'text.link.dark',
  _hover: {
    color: 'text.link.dark',
    opacity: '.8'
  }
};
const variants$8 = {
  standard: baseStyle$a,
  onDark: linkOnDark
};
const defaultProps$5 = {
  variant: 'standard'
};
var Link_styles = merge(theme$2.components.Link, {
  baseStyle: baseStyle$a,
  variants: variants$8,
  defaultProps: defaultProps$5
});

const { definePartsStyle: definePartsStyle$1, defineMultiStyleConfig: defineMultiStyleConfig$1 } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle$9 = definePartsStyle$1({
    icon: {
        color: 'primary.default',
    },
    button: {
        display: 'flex',
        gridGap: 3.5,
        alignItems: 'center',
        fontSize: 'sm',
        fontWeight: 'semibold',
        _hover: {
            backgroundColor: 'gray.50',
        },
    },
    container: {
        borderColor: 'gray.medium',
    },
});

const variants$7 = {
    lined: {
        button: {
            px: 2,
            py: 3,
        },
        container: {
            borderTopWidth: 1,
            _last: {
                borderBottomWidth: 1,
            },
        },
        panel: {
            px: 2,
            py: 3,
        },
    },
    contained: {
        button: {
            px: 4,
            py: 3,
        },
        container: {
            borderLeftWidth: 1,
            borderRightWidth: 1,
            _first: {
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
            },
            _last: {
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
            },
        },
        panel: {
            p: 4,
            borderColor: 'gray.medium',
            borderTopWidth: 1,
        },
    },
    // Chakra 2 upgrade broke styles for accordion and some work was done with these components.  to have it default to default makes it so styles that are implemented will be handled.  This is just as a backup
    unstyled: {
        icon: {
            color: 'inherit',
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            fontSize: 'default',
            fontWeight: 'normal',
            _hover: {
                backgroundColor: 'inherit',
            },
            paddingTop: '4',
            paddingBottom: '4',
        },
        container: {
            borderColor: 'inherit',
        },
    }
};

const defaultProps$4 = {
    variant: 'lined',
};

const accordionTheme = defineMultiStyleConfig$1({ 
    baseStyle: baseStyle$9,
    variants: variants$7,
    //TODO: add @rollup/plugin-typescript to this project
    //@ts-expect-error - This is due to babel not having a ts parser in it
    defaultProps: defaultProps$4,
});

const theme$1 = extendTheme({
  ...accordionTheme,
});

const colorScheme = {
  low: {
    borderColor: 'gray.100'
  },
  medium: {
    borderColor: 'gray.200'
  }
};
var Divider_styles = merge(theme$2.components.Divider, {
  colorScheme
});

const baseStyle$8 = {
  field: {
    fontFamily: fonts.body,
    fontWeight: fontWeights.normal
  }
};
const variants$6 = {
  outline: {
    field: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'inherit',
      _hover: {
        borderColor: 'gray.300'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'error',
        boxShadow: t => "0 0 0 1px ".concat(t.colors.error)
      },
      _focus: {
        borderColor: 'primary.400',
        boxShadow: t => "0 0 0 1px ".concat(t.colors.primary['400'])
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'gray.100'
    }
  }
};
var selectStyles = merge(theme$2.components.Select, {
  baseStyle: baseStyle$8,
  variants: variants$6
});

const baseStyle$7 = {
  container: {
    _disabled: {
      cursor: 'not-allowed'
    }
  },
  control: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderImage: 'initial',
    borderRadius: 'sm',
    borderColor: 'gray.600',
    transition: 'all 150ms ease',
    marginTop: 1.5,
    _readOnly: {
      boxShadow: 'none !important',
      userSelect: 'all'
    },
    _disabled: {
      cursor: 'not-allowed',
      userSelect: 'none',
      borderColor: 'gray.200'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    },
    _checked: {
      borderColor: 'primary.default',
      backgroundColor: 'primary.default',
      _hover: {
        borderColor: 'primary.600',
        backgroundColor: 'primary.600'
      },
      _disabled: {
        borderColor: 'gray.200',
        backgroundColor: 'gray.200'
      }
    },
    '& svg': {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    }
  },
  label: {
    _disabled: {
      color: 'gray.200',
      cursor: 'not-allowed'
    }
  },
  icon: {
    color: 'white'
  }
};
const sizes$4 = {
  sm: {
    control: {
      marginTop: '0.3125rem',
      width: 3,
      height: 3
    },
    icon: {
      width: 2.5,
      height: 2
    }
  },
  md: {
    control: {
      marginTop: 1,
      width: 4,
      height: 4
    },
    icon: {
      width: 3,
      height: 2.5
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      marginTop: 1,
      width: 5,
      height: 5
    },
    icon: {
      width: 2.5,
      height: 2.5
    },
    label: {
      fontSize: 'md'
    }
  }
};
var index$8 = merge(theme$2.components.Checkbox, {
  baseStyle: baseStyle$7,
  sizes: sizes$4
});

const overrides$1 = {
  defaultProps: {
    colorScheme: 'primary',
    size: 'lg'
  },
  baseStyle: props => merge(theme$2.components.Switch.baseStyle(props), {
    track: {
      overflow: 'clip'
    },
    thumb: {
      transition: 'all 150ms ease',
      boxShadow: 'base',
      _hover: {
        boxShadow: 'md'
      }
    }
  })
};
var index$7 = _objectSpread2(_objectSpread2({}, theme$2.components.Switch), overrides$1);

const popperStyles = {
  borderRadius: 'base'
};

const body$2 = props => ({
  fontSize: 'sm'
});

const headerStyles = {
  marginBottom: 2,
  fontWeight: 'semibold'
};

const popoverContentStyles = _ref => {
  let {
    variant
  } = _ref;
  return {
    padding: 4,
    marginBottom: 0,
    maxWidth: '20rem',
    borderRadius: 'base',
    background: variant === 'dark' ? 'secondary.default' : 'white',
    boxShadow: '2px 2px 4px 0 rgba(0,45,91,0.1)',
    color: variant === 'dark' ? 'white' : 'black',
    borderColor: 'gray.100',
    borderWidth: '1px',
    borderStyle: 'solid',
    '--popper-arrow-shadow-color': t => t.colors.gray['100'],
    zIndex: 'layer10',
    _focusVisible: {
      outline: '3px solid rgba(91, 170, 250, 0.7)'
    }
  };
};

const parts$1 = ['popper', 'content', 'header', 'body'];
const baseStyle$6 = props => ({
  header: headerStyles,
  content: popoverContentStyles(props),
  body: body$2(),
  popper: popperStyles
});
var index$6 = merge(theme$2.components.Popover, {
  parts: parts$1,
  baseStyle: baseStyle$6
});

const baseStyle$5 = {
  field: {
    fontFamily: 'body',
    _placeholder: {
      color: 'text.secondary.light',
      fontWeight: 'normal',
      _disabled: {
        color: 'text.secondary.light',
        opacity: 1
      }
    }
  }
};
const variants$5 = {
  outline: {
    field: {
      border: '1px solid',
      borderColor: 'gray.200',
      fontSize: 'base',
      paddingLeft: 3,
      paddingRight: 3,
      bg: 'inherit',
      fontWeight: 'normal',
      boxShadow: 'none !important',
      _placeholder: {
        color: 'text.secondary.light',
        fontWeight: 'normal'
      },
      _focus: {
        borderColor: 'primary.default'
      },
      _hover: {
        borderColor: 'gray.300'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        backgroundColor: 'gray.50',
        opacity: 1,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'error',
        _focus: {
          borderColor: 'error'
        }
      }
    }
  }
};
var inputStyles = merge(theme$2.components.Input, {
  baseStyle: baseStyle$5,
  variants: variants$5
});

//Below isn't being used in build for some reason
const variants$4 = {
  refreshed: {
    field: _objectSpread2(_objectSpread2({}, inputStyles.variants.outline.field), {}, {
      height: 'auto',
      paddingTop: 8,
      paddingBottom: 2
    })
  }
};
var index$5 = merge(inputStyles, {
  variants: variants$4
});

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const refreshed = definePartsStyle({
 field: {
    ...selectStyles.variants.outline.field,
    height: 'auto',
    paddingTop: 6,
    paddingBottom: 3,
  },
  icon: {
    ...selectStyles.variants.outline.field,
  }
});

const selectTheme = defineMultiStyleConfig({
  variants: { refreshed },
});

const theme = extendTheme({
  components: { Select: selectTheme },
});

const variants$3 = {
  refreshed: _objectSpread2(_objectSpread2({}, inputStyles.variants.outline.field), {}, {
    lineHeight: "6",
    width: "100%",
    paddingTop: 5.5,
    paddingBottom: 3,
    borderRadius: 'md',
    justifyContent: 'flex-start',
    minHeight: "14"
  })
};
var index$4 = merge(buttonStyles, {
  variants: variants$3
});

var overlay = {
  background: 'modalOverlay',
  zIndex: 'layer8'
};

var dialogContainer$1 = {
  display: 'flex',
  zIndex: 'layer8',
  justifyContent: 'center',
  alignItems: {
    base: 'flex-end',
    tablet: 'center'
  },
  height: '100%',
  minHeight: '-moz-available',
  minHeight: '-webkit-fill-available',
  minHeight: 'fill-available'
};

var dialog$1 = _ref => {
  let {
    hasFooter
  } = _ref;
  return {
    borderRadius: 'md',
    borderBottomRadius: {
      base: '0',
      tablet: 'md'
    },
    background: 'white',
    color: 'inherit',
    marginY: 0,
    zIndex: 'layer8',
    boxShadow: 'lg',
    paddingBottom: hasFooter ? 0 : 4
  };
};

var closeButton$1 = _ref => {
  let {
    hasHeader
  } = _ref;
  return {
    position: 'absolute',
    top: hasHeader ? 4 : 2,
    insetEnd: hasHeader ? 4 : 2,
    color: 'gray.dark',
    borderRadius: 'sm',
    width: 8,
    height: 8,
    _focus: {
      boxShadow: 'outline'
    },
    _hover: {
      bg: 'gray.50'
    }
  };
};

var body$1 = _ref => {
  let {
    hasFooter,
    hasHeader,
    hideCloseButton
  } = _ref;
  const scrollingHeaderStyles = hasHeader || !hideCloseButton ? {
    // The following adapted from https://lea.verou.me/2012/04/background-attachment-local/
    background: 'linear-gradient(white 30%, white), linear-gradient(rgb(0 0 0 / 10%) 0%, white)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
    backgroundSize: '100% 30px, 100% 10px',
    backgroundAttachment: 'local, scroll'
  } : {};
  return _objectSpread2({
    borderBottomRadius: hasFooter ? null : 'md',
    paddingX: 4,
    paddingBottom: 4,
    flex: 1,
    overflow: 'auto',
    display: 'flex'
  }, scrollingHeaderStyles);
};

var footer$1 = {
  borderTop: '1px',
  borderColor: 'gray.100',
  padding: 4
};

const baseStyle$4 = props => ({
  overlay,
  dialogContainer: dialogContainer$1,
  header: header$1(props),
  dialog: dialog$1(props),
  closeButton: closeButton$1(props),
  body: body$1(props),
  footer: footer$1
});
const sizes$3 = {
  sm: {
    dialog: {
      // Would have preferred object syntax here and below, but wasn't working for whatever reason
      maxWidth: ['100%', '100%', '48%', '32%', '24%'],
      maxHeight: ['100%', '100%', '60%', '48%', '32%'],
      minHeight: ['auto', 'auto', '32%', '32%', '24%']
    }
  },
  md: {
    dialog: {
      maxWidth: ['100%', '100%', '84%', '60%', '48%'],
      maxHeight: ['100%', '100%', '96%', '84%', '60%'],
      minHeight: ['auto', 'auto', '84%', '60%', '48%']
    }
  },
  lg: {
    dialog: {
      maxWidth: ['100%', '100%', '96%', '84%', '72%'],
      maxHeight: ['100%', '100%', '96%', '96%', '84%'],
      minHeight: ['auto', 'auto', '96%', '84%', '72%']
    }
  }
};
var index$3 = merge(theme$2.components.Modal, {
  baseStyle: baseStyle$4,
  sizes: sizes$3
});

const parts = ['control', 'label'];
const baseStyle$3 = {
  container: {
    alignItems: 'start'
  },
  control: {
    borderRadius: '50%',
    borderWidth: '1px',
    borderColor: 'gray.dark',
    backgroundColor: 'white',
    color: 'white',
    minWidth: 5,
    minHeight: 5,
    marginTop: 1,
    transition: 'all 150ms ease',
    _before: {
      content: '""',
      display: 'inline-block',
      position: 'relative',
      width: '0px',
      height: '0px',
      opacity: '0',
      borderRadius: '50%',
      background: 'currentcolor',
      transition: 'all 150ms ease-in',
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    },
    _checked: {
      borderColor: 'primary.default',
      color: 'white',
      backgroundColor: 'primary.default',
      _before: {
        width: 2,
        height: 2,
        opacity: '1'
      }
    },
    _focus: {
      boxShadow: 'outline'
    },
    _disabled: {
      borderColor: 'gray.200',
      _checked: {
        backgroundColor: 'gray.200'
      }
    }
  },
  label: {
    fontSize: 'base',
    color: 'black',
    marginLeft: 3,
    _disabled: {
      color: 'gray.200'
    }
  }
};
const sizes$2 = {
  sm: {
    control: {
      minWidth: 4,
      minHeight: 4,
      _checked: {
        _before: {
          width: 1.5,
          height: 1.5
        }
      }
    }
  },
  md: {
    control: {
      minWidth: 5,
      minHeight: 5,
      _checked: {
        _before: {
          width: 2,
          height: 2
        }
      }
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      minWidth: 6,
      minHeight: 6,
      _checked: {
        _before: {
          width: 2.5,
          height: 2.5
        }
      }
    },
    label: {
      fontSize: 'md'
    }
  }
};
const defaultProps$3 = {
  size: sizes$2.md
};
var index$2 = merge(theme$2.components.Radio, {
  parts,
  baseStyle: baseStyle$3,
  sizes: sizes$2,
  defaultProps: defaultProps$3
});

var Skeleton_styles = theme$2.components.Skeleton;

const baseStyle$2 = {
  px: 1,
  textTransform: 'reset',
  fontSize: 'xs',
  borderRadius: 'sm',
  fontWeight: 'bold'
};
const variants$2 = {
  primary: {
    bg: 'primary.default',
    color: 'white'
  },
  warningLight: {
    bg: 'yellow.100',
    color: 'black'
  }
};
const defaultProps$2 = {};
var index$1 = merge(theme$2.components.Badge, {
  variants: variants$2,
  baseStyle: baseStyle$2,
  defaultProps: defaultProps$2
});

const _excluded$i = ["hasFooter"];
const body = _ref => {
  let {
      hasFooter
    } = _ref;
    _objectWithoutProperties(_ref, _excluded$i);
  return {
    overflowY: 'auto',
    padding: 6,
    paddingBottom: hasFooter ? 24 : 6
  };
};
const footer = props => {
  return {
    padding: 6,
    backgroundColor: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%'
  };
};
const header = props => {
  return {
    paddingY: 3,
    paddingX: 6,
    borderBottom: '1px solid',
    borderBottomColor: 'gray.100',
    display: 'flex',
    gridGap: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 'semibold'
  };
};
const closeButton = props => {
  return {
    width: 8,
    height: 8,
    fontSize: 'xs',
    background: 'transparent',
    borderRadius: 'md',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    color: 'gray.600',
    _hover: {
      color: 'black',
      background: 'gray.100'
    },
    _focus: {
      outlineColor: 'primary.default'
    }
  };
};
const dialogContainer = props => {
  return {
    zIndex: 'layer2',
    backgroundColor: 'transparent'
  };
};
const dialog = props => {
  return {
    backgroundColor: 'white',
    boxShadow: 'drawer'
  };
};
const baseStyle$1 = props => ({
  body: body(props),
  footer: footer(),
  header: header(),
  dialog: dialog(),
  closeButton: closeButton(),
  dialogContainer: dialogContainer()
});
const defaultProps$1 = {
  size: 'xs'
};
const sizes$1 = {
  xs: {
    dialog: {
      maxWidth: {
        base: '100vw',
        mobileXL: 80
      }
    }
  }
};
var index = merge(theme$2.components.Drawer, {
  defaultProps: defaultProps$1,
  baseStyle: baseStyle$1,
  sizes: sizes$1
});

const filledStyle = props => {
  var _theme$colors$colorSc;
  const {
    colorScheme,
    hasStripe,
    isIndeterminate,
    theme
  } = props;
  const color = ((_theme$colors$colorSc = theme.colors[colorScheme]) === null || _theme$colors$colorSc === void 0 ? void 0 : _theme$colors$colorSc[500]) || 'gray.500'; // Default to gray if color is not found

  // Define the gradient for indeterminate progress bar
  const gradient = "linear-gradient(\n        to right,\n        transparent 0%,\n        ".concat(color, " 50%,\n        transparent 100%\n    )");

  // Manually define the stripe pattern using repeating-linear-gradient
  const stripeBackground = hasStripe && !isIndeterminate ? "repeating-linear-gradient(\n            45deg,\n            ".concat(color, " 0px,\n            ").concat(color, " 10px,\n            transparent 10px,\n            transparent 20px\n          )") : null;
  return _objectSpread2(_objectSpread2({}, stripeBackground && {
    backgroundImage: stripeBackground
  }), isIndeterminate ? {
    backgroundImage: gradient
  } : {
    backgroundColor: color
  });
};
const variantOutlined = props => {
  const {
    theme: {
      colors
    }
  } = props;
  return {
    track: {
      bg: 'transparent',
      borderWidth: '1px',
      borderColor: colors.gray['200']
    }
  };
};
const variantSolid = props => {
  const {
    theme: {
      colors
    }
  } = props;
  return {
    track: {
      bg: colors.gray['100']
    }
  };
};
const variants$1 = {
  outlined: variantOutlined,
  solid: variantSolid
};
const sizes = {
  xl: {
    track: {
      height: 10
    }
  },
  lg: {
    track: {
      height: 6
    }
  },
  md: {
    track: {
      height: 4
    }
  },
  sm: {
    track: {
      height: 2
    }
  },
  xs: {
    track: {
      height: 1
    }
  }
};
const defaultProps = {
  size: 'lg',
  colorScheme: 'primary',
  variant: 'solid'
};
const overrides = {
  defaultProps,
  variants: variants$1,
  sizes,
  baseStyle: props => {
    const {
      sx: {
        isRounded
      }
    } = props;
    return merge(theme$2.components.Progress.baseStyle(props), {
      filledTrack: _objectSpread2({
        borderRightRadius: isRounded ? 'none' : 'base'
      }, filledStyle(props)),
      track: {
        borderRightRadius: isRounded ? 'full' : 'base',
        borderLeftRadius: isRounded ? 'full' : 'base'
      }
    });
  }
};
var Progress_styles = _objectSpread2(_objectSpread2({}, theme$2.components.Progress), overrides);

const baseStyle = {
  button: {
    px: 8,
    py: 3,
    fontSize: 'base',
    fontFamily: 'body',
    lineHeight: 0.875,
    fontWeight: 'semibold',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'base',
    textTransform: 'capitalize',
    transition: 'all normal ease',
    _hover: {
      bg: 'gray.50',
      borderColor: 'gray.200'
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: 1,
      bg: 'gray.200',
      borderColor: 'gray.200',
      color: 'gray.600'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  list: {
    bg: 'white',
    boxShadow: 'base',
    padding: 6,
    zIndex: 'layer1',
    width: 64
  },
  item: {
    paddingX: 2,
    paddingY: 1.5,
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  groupTitle: {
    fontWeight: 'semibold',
    color: 'gray.600',
    padding: 2
  },
  command: {
    // this will style the text defined by the command
    // prop in the MenuItem and MenuItemOption components
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    paddingL: 4
  },
  divider: {
    marginY: 2,
    borderColor: 'gray.200'
  }
};
const variants = {
  basic: {
    button: {
      bg: 'primary.default',
      borderColor: 'primary.default',
      color: 'white',
      _hover: {
        bg: 'primary.600',
        borderColor: 'primary.600',
        color: 'white',
        _disabled: {
          bg: 'gray.200',
          borderColor: 'gray.200',
          color: 'gray.600'
        }
      }
    },
    list: {
      bg: 'white',
      boxShadow: 'base',
      zIndex: 'layer1',
      borderColor: 'gray.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 'base',
      padding: 4,
      width: 64
    },
    groupTitle: {
      fontWeight: 'semibold',
      fontSize: 'md',
      color: 'gray.600',
      padding: 2
    },
    item: {
      fontWeight: 'semibold',
      _hover: {
        color: 'gray.600'
      }
    }
  },
  full: {
    button: {
      height: 8,
      fontSize: 'sm',
      fontWeight: 'semibold',
      color: 'black',
      borderColor: 'white',
      backgroundColor: 'white',
      borderRadius: 'base',
      paddingX: 3,
      paddingY: 'auto',
      _hover: {
        color: 'black',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50'
      },
      _active: {
        color: 'primary.default',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50',
        _hover: {
          color: 'primary.600',
          backgroundColor: 'gray.50',
          borderColor: 'gray.50'
        }
      }
    },
    list: {
      height: '30rem',
      width: '100vw',
      padding: 8,
      backgroundColor: 'white'
    },
    groupTitle: {
      fontSize: 'sm',
      weight: 'normal',
      color: 'gray.600'
    },
    item: {
      display: 'block',
      paddingX: 3.5,
      paddingY: 2.5,
      marginBottom: 2,
      _last: {
        marginBottom: 0
      },
      _hover: {
        backgroundColor: 'gray.50'
      },
      _focus: {
        boxShadow: 'none',
        backgroundColor: 'gray.50'
      }
    }
  }
};
var Menu_styles = merge(theme$2.components.Menu, {
  baseStyle,
  variants
});

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Accordion: theme$1,
  Badge: index$1,
  Button: buttonStyles,
  ButtonRefreshed: index$4,
  Checkbox: index$8,
  Divider: Divider_styles,
  Drawer: index,
  GridItem: styles$1,
  Heading: Heading_styles,
  Input: inputStyles,
  InputRefreshed: index$5,
  Link: Link_styles,
  List: index$9,
  Menu: Menu_styles,
  Modal: index$3,
  Popover: index$6,
  Progress: Progress_styles,
  Radio: index$2,
  Select: selectStyles,
  SelectRefreshed: theme,
  Skeleton: Skeleton_styles,
  Spinner: Spinner_styles,
  Switch: index$7,
  Table: Table_styles,
  Tabs: styles$2,
  Text: Text_styles
});

// use this to extend the base theme of chakra, this adds on top of what is defined in baseConfig
const extendedTheme = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  styles: {
    global
  },
  remToPixels: function (rem) {
    let baseSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    return !rem ? 0 : "".concat(baseSize * Number(rem.replace('rem', '')));
  }
};

// use this to override base themes from Chakra
const baseConfig = _objectSpread2(_objectSpread2(_objectSpread2({}, theme$2), {}, {
  breakpoints
}, base), {}, {
  components
});
var THEME = extendTheme(extendedTheme, baseConfig);

const _excluded$h = ["theme", "useLegacyOverrides", "disableExternalFonts", "children"];
const ThemeProvider = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      theme,
      useLegacyOverrides,
      disableExternalFonts = false,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$h);
  return /*#__PURE__*/React__default.createElement(ChakraProvider, _extends$6({}, props, {
    ref: ref,
    theme: merge(THEME, theme)
  }), disableExternalFonts ? null : /*#__PURE__*/React__default.createElement(Fonts, null), /*#__PURE__*/React__default.createElement(LegacyOverrides, {
    useLegacyOverrides: useLegacyOverrides
  }), children);
});
ThemeProvider.propTypes = {
  /** If true, this will use the old `spothero-html` base styles */
  useLegacyOverrides: PropTypes.bool,
  /** If true, this will not load the `Fonts` global styles */
  disableExternalFonts: PropTypes.bool,
  /** The React node (generally your entire App) that will be provided the theme */
  children: PropTypes.node,
  /** Adds additional themeing on top of SpotHero's default configuration */
  theme: PropTypes.object
};

const Card = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(Box, _extends$6({
  position: "relative",
  padding: 4,
  bgColor: "background.white",
  borderRadius: "lg",
  boxShadow: "md"
}, props, {
  ref: ref
})));

const _excluded$g = ["isSSR", "cloudinaryImageId", "cloudinaryTemplate", "cloudinaryCloudName", "htmlWidth", "htmlHeight", "quality", "lazyLoad"];

// This code is copied from fe-utils https://github.com/spothero/fe-monorepo/blob/a0e06482e74dcb5502b21c5fbf0a679752a1f8ce/packages/fe-utils/src/environment/environment.js#L391
function isHighDensityDisplay() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
}
const buildCloudinarySrc = _ref => {
  let {
    cloudinaryImageId,
    cloudinaryTemplate,
    cloudinaryCloudName,
    htmlWidth,
    htmlHeight,
    quality
  } = _ref;
  const defaultTemplate = "https://res.cloudinary.com/".concat(cloudinaryCloudName, "/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,f_auto,fl_progressive,dpr_").concat(isHighDensityDisplay() ? 2 : 1, ",h_$h,q_$q,w_$w/").concat(cloudinaryImageId);
  const tmpl = cloudinaryTemplate ? cloudinaryTemplate : defaultTemplate;
  return template(tmpl, {
    interpolate: /{{([\s\S]+?)}}/g // matches template vars in the format '{{ var }}' or '{{var}}'
  })({
    WIDTH: htmlWidth,
    HEIGHT: htmlHeight,
    QUALITY: quality
  });
};
const Image = _ref2 => {
  let {
      isSSR,
      cloudinaryImageId,
      cloudinaryTemplate,
      cloudinaryCloudName,
      htmlWidth,
      htmlHeight,
      quality,
      lazyLoad
    } = _ref2,
    otherProps = _objectWithoutProperties(_ref2, _excluded$g);
  const hasValidCloudinarySrc = (cloudinaryImageId || cloudinaryTemplate) && Boolean(htmlWidth) && Boolean(htmlHeight);
  let cloudinarySrc;
  if (hasValidCloudinarySrc) {
    cloudinarySrc = buildCloudinarySrc({
      cloudinaryImageId,
      cloudinaryTemplate,
      cloudinaryCloudName,
      htmlWidth,
      htmlHeight,
      quality
    });
  }
  const imageProps = _objectSpread2(_objectSpread2({}, otherProps), {}, {
    src: cloudinarySrc || otherProps.src,
    htmlWidth,
    htmlHeight
  }, lazyLoad && {
    loading: 'lazy'
  });
  if (isSSR) {
    return /*#__PURE__*/React__default.createElement(Img, imageProps);
  } else {
    return /*#__PURE__*/React__default.createElement(Image$1, imageProps);
  }
};
Image.propTypes = {
  /** If true, use the image directly without client side checks. */
  isSSR: PropTypes.bool,
  /** The Cloudinary account that this image is stored under. */
  cloudinaryCloudName: PropTypes.string,
  /** The image ID that is stored in Cloudinary for this image. Will be used to replace the source path. */
  cloudinaryImageId: PropTypes.string,
  /** The template URL to use to create the source path from. Replaceable values are {{WIDTH}}, {{HEIGHT}}, and {{QUALITY}}. */
  cloudinaryTemplate: PropTypes.string,
  /** The width of the native HTML image, in pixels. Required if using a Cloudinary ID or Template. */
  htmlWidth: PropTypes.number,
  /** The height of the native HTML image, in pixels. Required if using a Cloudinary ID or Template. */
  htmlHeight: PropTypes.number,
  /** The quality setting if this image uses a Cloudinary ID or Template. */
  quality: PropTypes.number,
  /** Whether to use lazy loading for this image. */
  lazyLoad: PropTypes.bool
};
Image.defaultProps = {
  isSSR: false,
  quality: 50,
  cloudinaryCloudName: 'spothero'
};

const _excluded$f = ["color", "loaderBackgroundColor", "isInfinite", "size", "thickness", "trackColor", "value"];
const Loader = _ref => {
  let {
      color = 'success',
      loaderBackgroundColor = 'transparent',
      isInfinite = true,
      size = 12,
      thickness = 2,
      trackColor = 'gray.medium',
      value = 0
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$f);
  /* -------------------------------------------------------------------- *\
      Note: Since most of the props for this component control multiple
      styles at a time, it was decided that it made the most sense to set
      up the default style-related properties here in lou of creating an
      overly complex styles file.
  \* -------------------------------------------------------------------- */
  const loaderDefaultProps = {
    color,
    isIndeterminate: isInfinite,
    size,
    thickness,
    trackColor,
    value,
    capIsRound: true
  };
  return /*#__PURE__*/React__default.createElement(CircularProgress, _extends$6({
    sx: {
      '& svg > circle:first-of-type': {
        fill: loaderBackgroundColor
      }
    }
  }, loaderDefaultProps, props));
};
Loader.propTypes = {
  /**
   * The color of the Progress bar. Use color names defined within `theme/base/colors`.
   */
  color: PropTypes.string,
  /**
   * Determines if Loader spins for an infinite amount of time. If `true` value prop will be ignored.
   */
  isInfinite: PropTypes.bool,
  /**
   * Sets the background color of the Loader (inside the circle). Use color names defined within `theme/base/colors`.
   */
  loaderBackgroundColor: PropTypes.string,
  /**
   * The size of the Loader. Used as both height and width. Number corresponds to Size token.
   */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The thickness of the Loader. Number is used as pixel width.
   */
  thickness: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The color of the Progress bar track.  Use color names defined within `theme/base/colors`.
   */
  trackColor: PropTypes.string,
  /**
   * The number passed in corresponds to the percentage "done" of the Loader.
   */
  value: PropTypes.number
};

const _excluded$e = ["isRounded"];
const Progress = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      isRounded
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$e);
  // Passing `isRounded` in as a prop throws a 'React does not recognize the X prop on a DOM element' error. Passing `isRounded` through `sx` instead, allows for the prop to be utilized by the theme without being set on the DOM element, avoiding the error.
  return /*#__PURE__*/React__default.createElement(Progress$1, _extends$6({
    ref: ref,
    sx: {
      isRounded
    }
  }, props));
});
Progress.propTypes = {
  /** The visual color appearance of the component */
  colorScheme: PropTypes.string,
  /** If true, the progress bar will show a stripe */
  hasStripe: PropTypes.bool,
  /** If true, and hasStripe is true, the stripes will be animated */
  isAnimated: PropTypes.bool,
  /** If true, the progress will be indeterminate and the value prop will be ignored */
  isIndeterminate: PropTypes.bool,
  /** If true, the Progress Bar and Track are rounded */
  isRounded: PropTypes.bool,
  /** The maximum value of the Progress Bar */
  max: PropTypes.number,
  /** The minimum value of the Progress Bar */
  min: PropTypes.number,
  /** The size of the Progress */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** The value of the progress indicator. If undefined the progress bar will be in indeterminate state */
  value: PropTypes.number,
  /** The visual appearance of the Progress Bar */
  variant: PropTypes.oneOf(['solid', 'outlined'])
};
Progress.defaultProps = {
  colorScheme: 'primary',
  hasStripe: false,
  isAnimated: false,
  isIndeterminate: false,
  isRounded: false,
  max: 100,
  min: 0,
  size: 'md',
  value: 0,
  variant: 'solid'
};

const _excluded$d = ["defaultChecked", "isChecked", "isDisabled", "value", "helperText", "children", "size"];
const Checkbox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      defaultChecked,
      isChecked,
      isDisabled,
      value,
      helperText,
      children,
      size = 'md'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$d);
  const helperTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  return /*#__PURE__*/React__default.createElement(Checkbox$1, _extends$6({
    ref: ref,
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    alignItems: "start",
    size: size
  }, props), children, helperText && /*#__PURE__*/React__default.createElement(Box, {
    color: "gray.600",
    fontSize: helperTextSize
  }, helperText));
});
Checkbox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

const _excluded$c = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "customRequiredText"];
const Input$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      isOptional,
      customRequiredText
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$c);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    isOptional: isOptional,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id,
    customRequiredText: customRequiredText
  }, /*#__PURE__*/React__default.createElement(Input$2, _extends$6({
    ref: ref,
    className: classes
  }, props)));
});
Input$1.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  customRequiredText: PropTypes.string
};

const _excluded$b = ["label", "helperText", "errorMessage", "id", "children", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles"];

// No clue how to move these into the style file so just co-located to keep from slowing down
// Chakra V2 will heavily impact this component
const labelStyle = {
  color: 'gray.600',
  fontWeight: 'normal',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  top: 0,
  left: 0,
  position: 'absolute',
  pointerEvents: 'none',
  padding: 'inherit',
  paddingLeft: 3,
  transformOrigin: 'left top',
  // below is from chakra v2 that I'm pulling in
  transitionProperty: 'scale translate',
  transitionDuration: '200ms'
};
const activeLabelStyles = {
  fontSize: '0.85em',
  transform: 'translateY(-.75rem)',
  _invalid: {
    color: 'error',
    '& .chakra-form__required-indicator': {
      display: 'none'
    }
  }
};
const controlStyles = {
  position: 'relative',
  borderWidth: '0',
  sx: {
    label: labelStyle,
    input: {
      '&::placeholder': {
        // below is from chakra v2 that I'm pulling in
        transitionProperty: 'opacity scale translate',
        transitionDuration: '200ms',
        opacity: 0
      },
      _invalid: {
        '&:focus + label': {
          color: 'gray.600'
        },
        '& + label': {
          color: 'error'
        },
        '& + label .chakra-form__required-indicator': {
          //Styling for asterisk always to be red if invalid
          color: 'error'
        },
        '&::placeholder': {
          opacity: 1
        }
      }
    },
    // styles used for when we extend functionality - textarea:not(:placeholder-shown) ~ label
    // on prod build we get style tag inject between input and label
    'input:not(:placeholder-shown) + label, input:not(:placeholder-shown) + style + label, .chakra-select__wrapper + label': _objectSpread2({}, activeLabelStyles),
    // should be a cleaner way of doing this
    '.chakra-input__group > .chakra-input__left-element ~ span input': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group:not(:has(.fe-ui-async-select__control)) > .chakra-input__left-element ~ span input': {
      minHeight: 14 // same height as the button
    },
    '.chakra-input__group > .chakra-input__left-element ~ span select': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span button': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span label': {
      // transform: 'scale(0.85) translateY(-1rem) translateX(.5rem)',
      paddingLeft: '2.5rem'
    },
    // Styling for select
    '.chakra-select__wrapper + label': _objectSpread2({}, activeLabelStyles),
    '.FormElement-contains-error': {
      borderColor: 'error'
    },
    '.chakra-button + label': _objectSpread2(_objectSpread2({}, activeLabelStyles), {}, {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      marginLeft: '1px'
      // marginTop: 2
    }),
    // Styling for async select
    '.chakra-input__group:has(.fe-ui-async-select__single-value) label': _objectSpread2({}, activeLabelStyles)
  },
  _focusWithin: {
    label: _objectSpread2({}, activeLabelStyles),
    input: {
      '&::placeholder': {
        opacity: '1'
      }
    }
  }
};

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * This formControl allows us to standardize the label movement animation as well as the left/right icons
 * Can be used solo but typically will be used by the Refreshed components themselves
 */
const FormControl = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      id = '',
      children,
      rightElement,
      leftElement,
      rightElementStyles,
      leftElementStyles
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$b);
  return /*#__PURE__*/React__default.createElement(FormControl$2, _extends$6({}, props, {
    ref: ref
  }, controlStyles), /*#__PURE__*/React__default.createElement(InputGroup, null, leftElement && /*#__PURE__*/React__default.createElement(InputLeftElement, _extends$6({
    pointerEvents: "none",
    top: "52%",
    left: "1.3rem",
    transform: "translate(-50%,-50%)"
  }, leftElementStyles), leftElement), /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    width: "100%",
    position: "relative"
  }, children, label && /*#__PURE__*/React__default.createElement(FormLabel, {
    htmlFor: id
  }, label)), rightElement && /*#__PURE__*/React__default.createElement(InputRightElement, _extends$6({
    top: "50%",
    right: "-1rem",
    transform: "translate(-50%,-50%)"
  }, rightElementStyles), rightElement)), helperText && /*#__PURE__*/React__default.createElement(FormHelperText, {
    color: "gray.600",
    marginTop: 1,
    fontSize: "xs"
  }, helperText), errorMessage && /*#__PURE__*/React__default.createElement(FormErrorMessage, {
    color: "error",
    marginTop: 1,
    fontSize: "xs"
  }, errorMessage));
});
FormControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  // Or react node
  helperText: PropTypes.string,
  // Or react node
  errorMessage: PropTypes.string,
  // Or react node
  children: PropTypes.element,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool
};

const _excluded$a = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles", "placeholder"];

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedInput/>` will bring in the core of this.
 */
const Input = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      rightElement,
      leftElement,
      rightElementStyles,
      leftElementStyles,
      placeholder = ' '
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$a);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  }); //Historic carry over

  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles,
    variant: "refreshed"
  }, /*#__PURE__*/React__default.createElement(Input$2, _extends$6({
    placeholder: placeholder,
    ref: ref,
    className: classes,
    paddingTop: 'var(--chakra-sizes-5-5)' // Design requires 5.5
    ,
    paddingBottom: "2",
    lineHeight: "base",
    variant: "refreshed"
  }, props)));
});
Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  leftElement: PropTypes.element,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object,
  leftElementStyles: PropTypes.object
};

const _excluded$9 = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles", "formControlStyles"];

//For select left is static arrow,
/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedSelect><option value="1"/>/<RefreshedSelect>` will bring in the core of this.
 * Left arrow is static for this select.  You can pass a second left element in but it will not over write the down arrow currently
 */
const Select = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      isOptional,
      rightElement,
      leftElement,
      rightElementStyles,
      leftElementStyles,
      formControlStyles
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$9);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles,
    sx: formControlStyles
  }, /*#__PURE__*/React__default.createElement(Select$2, _extends$6({
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      as: ForwardRef$1
    }),
    iconSize: 20,
    fontSize: "sm",
    ref: ref,
    className: classes,
    variant: "refreshed"
  }, props)));
});
Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object
};

const _excluded$8 = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isHighlighted", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles", "buttonValue"];

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedButton/>` will bring in the core of this.
 * The "value" will be the child of the button but must be passed through props like: `<RefreshedButton buttonValue="123"/>`.  This aids in the styling.
 * Recommended to pass a title prop as that will aid in screen readers understanding this due to text not always being in the button
 */
const Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      isHighlighted,
      rightElement,
      leftElement,
      rightElementStyles,
      leftElementStyles,
      buttonValue
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$8);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  }); //Historic carry over

  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles,
    variant: "refreshed"
  }, /*#__PURE__*/React__default.createElement(Button$2, _extends$6({
    ref: ref,
    className: classes,
    variant: "refreshed",
    "data-value": buttonValue,
    paddingBottom: "2"
  }, props, {
    isDisabled: isDisabled,
    color: isInvalid || !label ? 'gray.600' : 'black',
    borderColor: isInvalid ? 'error' : isHighlighted ? 'primary.default' : 'gray.200',
    _focus: {
      borderColor: isInvalid ? 'error' : 'primary.default'
    },
    _hover: {
      borderColor: isHighlighted ? 'primary.default' : 'gray.300'
    },
    paddingTop: label ? 'var(--chakra-sizes-5-5)' : '3',
    textTransform: "none"
  }), buttonValue));
});
Button.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  leftElement: PropTypes.element,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object,
  leftElementStyles: PropTypes.object,
  buttonValue: PropTypes.string
};

var _path, _path2;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var SvgXCircle = function SvgXCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10m0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXCircle);

const AutoSuggestSelect$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    label,
    helperText,
    errorMessage,
    isInvalid,
    isDisabled,
    isRequired,
    getOptions,
    onChange,
    placeholder,
    defaultValue = null,
    leftElement,
    leftElementStyles
  } = _ref;
  const {
    colors,
    fontSizes,
    sizes
  } = useTheme();
  const handleChange = selectedOption => {
    onChange(selectedOption);
  };
  const baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  const customStyles = {
    menu: provided => _objectSpread2(_objectSpread2({}, provided), baseText),
    control: (provided, state) => _objectSpread2(_objectSpread2({}, provided), {}, {
      borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200'],
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['300']
      }
    }),
    input: (provided, state) => _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, provided), baseText), {}, {
      paddingBottom: sizes['2'],
      paddingTop: sizes['5.5'],
      paddingRight: sizes['3'],
      backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent'
    }, leftElement ? {
      paddingLeft: sizes['10']
    } : {
      paddingLeft: sizes['3']
    }), {}, {
      cursor: state.isDisabled ? 'not-allowed' : !state.hasValue ? 'text' : 'auto'
    }),
    placeholder: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: sizes['2'],
      fontSize: fontSizes.base,
      color: colors.gray['600']
    }),
    singleValue: provided => _objectSpread2(_objectSpread2(_objectSpread2({}, provided), baseText), {}, {
      paddingBottom: sizes['2'],
      paddingTop: sizes['5.5'],
      paddingRight: sizes['3']
    }, leftElement ? {
      paddingLeft: sizes['10']
    } : {
      paddingLeft: sizes['3']
    }),
    option: (provided, state) => _objectSpread2(_objectSpread2({}, provided), {}, {
      backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
      color: colors.black
    }),
    clearIndicator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      color: colors.gray['600']
    }),
    dropdownIndicator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      color: colors.gray['600']
    })
  };
  const clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  const ClearIndicator = _ref2 => {
    let {
      innerRef,
      innerProps
    } = _ref2;
    return /*#__PURE__*/React__default.createElement("div", _extends$6({
      style: clearIndicatorStyles,
      ref: innerRef
    }, innerProps), /*#__PURE__*/React__default.createElement(ForwardRef, null));
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: isInvalid ? {
      label: {
        color: 'error'
      }
    } : {}
  }, /*#__PURE__*/React__default.createElement(FormControl, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    id: id,
    leftElement: leftElement,
    leftElementStyles: leftElementStyles
  }, /*#__PURE__*/React__default.createElement(AsyncSelect, {
    classNamePrefix: "fe-ui-async-select",
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
      ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    inputId: id,
    placeholder: placeholder,
    defaultValue: defaultValue,
    styles: customStyles,
    ref: ref
  })));
});
AutoSuggestSelect$1.propTypes = {
  /** ID applied to the select and label */
  id: PropTypes.string.isRequired,
  /** Label that describes the select */
  label: PropTypes.string,
  /** Text to use as placeholder in the input */
  placeholder: PropTypes.string,
  /** Optional helper text displayed below the select */
  helperText: PropTypes.string,
  /** Error message that would display under the select */
  errorMessage: PropTypes.string,
  /** Boolean that sets whether the select is valid */
  isInvalid: PropTypes.bool,
  /** Boolean that sets whether the select is disabled */
  isDisabled: PropTypes.bool,
  /** Boolean that sets whether the select is required */
  isRequired: PropTypes.bool,
  /** Function that is called with the value typed into the input that returns a list of options for the select */
  getOptions: PropTypes.func.isRequired,
  /** Function that is called when an option is selected, it returns the label and value of the selection */
  onChange: PropTypes.func.isRequired,
  // This prop is added to work around error: 'innerRef' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerRef: PropTypes.object,
  // This prop is added to work around error: 'innerProps' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerProps: PropTypes.object,
  // Element to display to the left of the input
  leftElement: PropTypes.element,
  // Styling of leftElement
  leftElementStyles: PropTypes.object
};

const _excluded$7 = ["defaultChecked", "isChecked", "isDisabled", "value", "helperText", "children", "size"];
const Radio = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      defaultChecked,
      isChecked,
      isDisabled,
      value,
      helperText,
      children,
      size = 'md'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$7);
  const helperTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  return /*#__PURE__*/React__default.createElement(Radio$1, _extends$6({
    ref: ref,
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    size: size
  }, props), children, helperText && /*#__PURE__*/React__default.createElement(Box, {
    color: "gray.600",
    fontSize: helperTextSize
  }, helperText));
});
Radio.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

const _excluded$6 = ["label", "errorMessage", "defaultValue", "isDisabled", "isInvalid", "isRequired", "name", "onChange", "value", "children", "direction"];
const RadioGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      errorMessage,
      defaultValue,
      isDisabled,
      isInvalid,
      isRequired,
      name,
      onChange,
      value,
      children,
      direction
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    label: label,
    inputId: props.id,
    isFieldset: true
  }, /*#__PURE__*/React__default.createElement(RadioGroup$1, _extends$6({
    ref: ref,
    defaultValue: defaultValue,
    name: name,
    onChange: onChange,
    value: value
  }, props), /*#__PURE__*/React__default.createElement(Stack, {
    direction: direction ? direction : 'column',
    gap: 0
  }, children)));
});
RadioGroup.propTypes = {
  children: PropTypes.node,
  defaultValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column'])
};

const _excluded$5 = ["isChecked", "isDisabled", "value", "helperText", "expandableChildren", "defaultChecked", "isRadio", "label", "isExpandable", "size", "expandableChildrenStyles", "topChild"];
const SelectionCard = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      isChecked,
      isDisabled,
      value,
      helperText,
      expandableChildren,
      defaultChecked,
      isRadio,
      label,
      isExpandable,
      size = 'md',
      expandableChildrenStyles = {},
      topChild
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$5);
  const Component = isRadio ? Radio : Checkbox;
  const expandableTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  const hasExpandableContent = isExpandable && isChecked && expandableChildren;
  const prefersReducedMotion = usePrefersReducedMotion();
  return /*#__PURE__*/React__default.createElement(Box, {
    paddingBottom: hasExpandableContent ? 3 : 0,
    borderRadius: "lg",
    borderColor: isChecked ? 'primary.default' : 'gray.medium',
    borderWidth: "1px",
    _hover: {
      borderColor: isDisabled ? 'gray.medium' : 'primary.default'
    },
    overflow: topChild ? 'hidden' : 'auto'
  }, topChild, /*#__PURE__*/React__default.createElement(Box, {
    borderColor: "gray.medium",
    borderBottomWidth: hasExpandableContent ? '1px' : 0
  }, /*#__PURE__*/React__default.createElement(Component, _extends$6({
    ref: ref,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    defaultChecked: defaultChecked,
    helperText: helperText,
    size: size,
    width: "100%",
    paddingX: 4,
    paddingY: 3
  }, props), label)), /*#__PURE__*/React__default.createElement(Box, {
    overflow: "hidden",
    display: "grid"
    // Using this as a pseudo height transition to get around no height auto transition
    ,
    gridTemplateRows: hasExpandableContent ? '1fr' : '0fr',
    opacity: hasExpandableContent ? '100%' : '0%',
    transition: prefersReducedMotion ? '' : 'all 150ms ease-out'
  }, /*#__PURE__*/React__default.createElement(Box, {
    overflow: "hidden"
  }, hasExpandableContent && /*#__PURE__*/React__default.createElement(Box, _extends$6({
    color: "gray.600",
    fontSize: expandableTextSize,
    paddingTop: 3,
    paddingX: 4
  }, expandableChildrenStyles), expandableChildren))));
});
SelectionCard.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  expandableChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  isRadio: PropTypes.bool,
  isExpandable: PropTypes.bool,
  expandableChildrenStyles: PropTypes.object,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  topChild: PropTypes.element
};

const _excluded$4 = ["variant", "colorScheme"];
const Divider = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      variant,
      colorScheme: borderColor
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React__default.createElement(Divider$1, _extends$6({}, colorScheme[borderColor], {
    variant: variant
  }, props, {
    ref: ref
  }));
});
Divider.propTypes = {
  /** Color scheme used */
  colorScheme: PropTypes.oneOf(['low', 'medium']),
  /** The styling that will be applied to the HR tag */
  variant: PropTypes.oneOf(['solid', 'dashed'])
};
Divider.defaultProps = {
  variant: 'solid',
  colorScheme: 'medium'
};

const _excluded$3 = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "customRequiredText"];
const Textarea = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      label,
      helperText,
      errorMessage,
      isInvalid,
      isDisabled,
      isRequired,
      isOptional,
      customRequiredText
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$3);
  const classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    isOptional: isOptional,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id,
    customRequiredText: customRequiredText
  }, /*#__PURE__*/React__default.createElement(Textarea$1, _extends$6({
    ref: ref,
    className: classes
  }, props)));
});
Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  customRequiredText: PropTypes.string
};

const _excluded$2 = ["children"];
const Popover = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded$2);
  return /*#__PURE__*/React__default.createElement(Popover$1, _extends$6({}, rest, {
    ref: ref
  }), Children.toArray(children).map((child, index) => /*#__PURE__*/cloneElement(child, {
    ref,
    variant: props.variant,
    key: "Popover-child-".concat(index)
  })));
});
Popover.propTypes = {
  /** React children */
  children: PropTypes.node,
  /** Styles the Popover */
  variant: PropTypes.oneOf(['light', 'dark'])
};

const arrowStyles = _ref => {
  let {
    variant
  } = _ref;
  return {
    backgroundColor: variant === 'dark' ? 'secondary.default' : 'white'
  };
};

const PopoverArrow = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React__default.createElement(PopoverArrow$1, _extends$6({
    ref: ref
  }, props, arrowStyles(props)));
});

const pseudoStyles = variant => ({
  bgColor: variant === 'dark' ? 'gray.600' : 'gray.50'
});
const closeButtonStyles = _ref => {
  let {
    variant
  } = _ref;
  return {
    color: variant === 'dark' ? 'white' : 'black',
    fontSize: '0.5rem',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 4,
    borderTopRightRadius: 4,
    _hover: pseudoStyles(variant),
    _focus: _objectSpread2(_objectSpread2({}, pseudoStyles(variant)), {}, {
      boxShadow: 'outline'
    })
  };
};

const PopoverCloseButton = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React__default.createElement(PopoverCloseButton$1, _extends$6({
    ref: ref
  }, props, closeButtonStyles(props)));
});

const _excluded$1 = ["header", "variant", "children", "hideCloseButton", "hideArrow", "popoverBodyProps"];
const PopoverContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      header,
      variant,
      children,
      hideCloseButton,
      hideArrow,
      popoverBodyProps
    } = props,
    rest = _objectWithoutProperties(props, _excluded$1);
  return /*#__PURE__*/React__default.createElement(PopoverContent$1, _extends$6({}, rest, {
    ref: ref
  }), hideArrow ? null : /*#__PURE__*/React__default.createElement(PopoverArrow, {
    variant: variant
  }), hideCloseButton ? null : /*#__PURE__*/React__default.createElement(PopoverCloseButton, {
    variant: variant
  }), header ? /*#__PURE__*/React__default.createElement(PopoverHeader, null, header) : null, /*#__PURE__*/React__default.createElement(PopoverBody, popoverBodyProps, children));
});
PopoverContent.propTypes = {
  /** React children */
  children: PropTypes.node,
  /** Whether or not to hide the close button */
  hideCloseButton: PropTypes.bool,
  /** Whether or not to hide the arrow */
  hideArrow: PropTypes.bool,
  /** Styles the Popover */
  variant: PropTypes.oneOf(['light', 'dark']),
  /** The string or node for the header (optional) */
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /** Props to pass to the PopoverBody */
  popoverBodyProps: PropTypes.object
};
PopoverContent.defaultProps = {
  variant: 'light',
  hideCloseButton: false,
  hideArrow: false
};

const AutoSuggestSelect = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    label,
    helperText,
    errorMessage,
    isInvalid,
    isDisabled,
    isRequired,
    getOptions,
    onChange,
    iconSrc,
    placeholder,
    defaultValue = null
  } = _ref;
  const {
    colors,
    fontSizes,
    sizes
  } = useTheme();
  const handleChange = selectedOption => {
    onChange(selectedOption);
  };
  const icon = function () {
    let color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
    return {
      alignItems: 'center',
      display: 'flex',
      ':before': {
        backgroundColor: color,
        content: '" "',
        display: 'block',
        marginRight: sizes['3'],
        height: sizes['4'],
        width: sizes['5'],
        mask: "url(".concat(iconSrc, ") no-repeat 50% 50%"),
        maskSize: 'contain'
      }
    };
  };
  const baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  const customStyles = {
    menu: provided => _objectSpread2(_objectSpread2({}, provided), baseText),
    control: (provided, state) => _objectSpread2(_objectSpread2({}, provided), {}, {
      borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200'],
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200']
      }
    }),
    input: (provided, state) => _objectSpread2(_objectSpread2(_objectSpread2({}, provided), baseText), {}, {
      padding: sizes['2'],
      backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent'
    }, iconSrc && icon(colors.gray['600'])),
    placeholder: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: sizes['2'],
      fontSize: fontSizes.base,
      color: colors.gray['600']
    }, iconSrc && icon()),
    singleValue: provided => _objectSpread2(_objectSpread2(_objectSpread2({}, provided), baseText), {}, {
      padding: sizes['2']
    }, iconSrc && icon()),
    option: (provided, state) => _objectSpread2(_objectSpread2({}, provided), {}, {
      backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
      color: colors.black
    }),
    clearIndicator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      color: colors.gray['600']
    }),
    dropdownIndicator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      color: colors.gray['600']
    })
  };
  const clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  const ClearIndicator = _ref2 => {
    let {
      innerRef,
      innerProps
    } = _ref2;
    return /*#__PURE__*/React__default.createElement("div", _extends$6({
      style: clearIndicatorStyles,
      ref: innerRef
    }, innerProps), /*#__PURE__*/React__default.createElement(ForwardRef, null));
  };
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/React__default.createElement(AsyncSelect, {
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
      ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    id: id,
    placeholder: placeholder,
    defaultValue: defaultValue,
    styles: customStyles,
    ref: ref
  }));
});
AutoSuggestSelect.propTypes = {
  /** ID applied to the select and label */
  id: PropTypes.string.isRequired,
  /** Label that describes the select */
  label: PropTypes.string,
  /** Text to use as placeholder in the input */
  placeholder: PropTypes.string,
  /** Optional helper text displayed below the select */
  helperText: PropTypes.string,
  /** Error message that would display under the select */
  errorMessage: PropTypes.string,
  /** Boolean that sets whether the select is valid */
  isInvalid: PropTypes.bool,
  /** Boolean that sets whether the select is disabled */
  isDisabled: PropTypes.bool,
  /** Boolean that sets whether the select is required */
  isRequired: PropTypes.bool,
  /** Function that is called with the value typed into the input that returns a list of options for the select */
  getOptions: PropTypes.func.isRequired,
  /** Function that is called when an option is selected, it returns the label and value of the selection */
  onChange: PropTypes.func.isRequired,
  /** Optional src to SVG to use as search icon */
  iconSrc: PropTypes.string,
  // This prop is added to work around error: 'innerRef' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerRef: PropTypes.object,
  // This prop is added to work around error: 'innerProps' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerProps: PropTypes.object
};

const defaultStyles = {
  border: 0,
  borderRadius: '4px',
  fontWeight: 'normal',
  paddingX: 4,
  paddingY: 1,
  _hover: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  },
  _focus: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  }
};
const inactiveStyles = {
  color: 'black',
  borderColor: 'gray.100',
  bg: 'gray.100',
  _hover: {
    bg: 'gray.100'
  },
  _active: {
    bg: 'gray.100'
  }
};
const activeStyles = {
  color: 'black',
  fontWeight: 'semibold',
  boxShadow: 'sm',
  bg: 'white',
  _hover: {
    bg: 'white'
  },
  _active: {
    bg: 'white'
  }
};
const buttonGroupStyles = {
  borderRadius: '4px',
  backgroundColor: 'gray.100',
  padding: 1
};

/**
 * @example (
 * <ToggleButtonGroup onChange={handleChangeValue} value={value}>
 *  <Button value={value1}>label1</Button>
 *  <Button value={value2}>label2</Button>
 * </ToggleButtonGroup>
 * )
 * @note
 * must have multiple child elements
 */
const ToggleButtonGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    onChange,
    value,
    children,
    groupProps,
    buttonGroupStyles: _buttonGroupStyles = {},
    childrenStyles = {}
  } = props;
  if (!children) throw new Error('Children required');

  // iterate over array of child nodes to apply extended props
  return /*#__PURE__*/React__default.createElement(ButtonGroup, _extends$6({
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, buttonGroupStyles), _buttonGroupStyles)
  }, groupProps), React__default.Children.map(children, CHILD => {
    var _CHILD$props3;
    return /*#__PURE__*/React__default.cloneElement(CHILD, _objectSpread2({
      onClick: () => {
        var _CHILD$props, _CHILD$props2;
        if (value === (CHILD === null || CHILD === void 0 || (_CHILD$props = CHILD.props) === null || _CHILD$props === void 0 ? void 0 : _CHILD$props.value)) return;
        onChange(CHILD === null || CHILD === void 0 || (_CHILD$props2 = CHILD.props) === null || _CHILD$props2 === void 0 ? void 0 : _CHILD$props2.value);
      }
    }, {
      sx: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultStyles), value !== (CHILD === null || CHILD === void 0 || (_CHILD$props3 = CHILD.props) === null || _CHILD$props3 === void 0 ? void 0 : _CHILD$props3.value) ? inactiveStyles : activeStyles), childrenStyles)
    }));
  }));
});
ToggleButtonGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  groupProps: PropTypes.object
};

const _excluded = ["id", "label", "isInvalid", "isLoading", "isRequired", "options", "placeholder", "errorMessage", "helperText", "innerRef"],
  _excluded2 = ["id", "label", "isInvalid", "isLoading", "isRequired", "options", "placeholder", "errorMessage", "helperText"];
const DropdownIndicator = props => {
  const {
    sizes
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(components$1.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(Icon, {
    className: "CreatableSelect-dropdown-icon",
    as: ForwardRef$1,
    boxSize: sizes['2.5']
  }));
};

// Exporting without forwardRef for storybook to work
const CreatableSelectNode = _ref => {
  let {
      id,
      label,
      isInvalid = false,
      isLoading = false,
      isRequired,
      options = [],
      placeholder = '',
      errorMessage,
      helperText,
      innerRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    colors,
    fontSizes
  } = useTheme();
  if (innerRef) {
    props.ref = innerRef;
  }
  const customStyles = {
    control: (provided, state) => _objectSpread2(_objectSpread2({}, provided), {}, {
      borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200'],
      borderWidth: '1px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary.default : colors.gray['200']
      }
    }),
    placeholder: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: fontSizes.sm,
      color: colors.gray['200']
    }),
    dropdownIndicator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      color: colors.brandBlue,
      '&:hover': {
        color: colors.brandBlue
      }
    }),
    indicatorSeparator: provided => _objectSpread2(_objectSpread2({}, provided), {}, {
      display: 'none'
    })
  };
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    isInvalid: isInvalid,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/React__default.createElement(Creatable, _extends$6({
    id: id,
    components: {
      DropdownIndicator
    },
    styles: customStyles,
    options: options,
    placeholder: placeholder,
    isLoading: isLoading
  }, props)));
};
const CreatableSelect = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      id,
      label,
      isInvalid = false,
      isLoading = false,
      isRequired,
      options = [],
      placeholder = '',
      errorMessage,
      helperText
    } = props,
    additionalProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React__default.createElement(CreatableSelectNode, _extends$6({
    id: id,
    innerRef: ref,
    label: label,
    options: options,
    placeholder: placeholder,
    helperText: helperText,
    errorMessage: errorMessage,
    isLoading: isLoading,
    isInvalid: isInvalid,
    isRequired: isRequired
  }, additionalProps));
});
CreatableSelect.propTypes = {
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string
};
CreatableSelectNode.propTypes = {
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  innerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Creatable)
  })
};
var CreatableSelect$1 = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(CreatableSelectNode, _extends$6({
  ref: ref
}, props)));

const Menu = forwardRef$1((props, ref) => {
  return /*#__PURE__*/React__default.createElement(Menu$1, _extends$6({}, props, {
    ref: ref
  }));
});
Menu.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node
};

export { AccordionActionButton, Alert, AlwaysMountedModal, AutoSuggestSelect, Button$1 as Button, Card, Checkbox, Container, CreatableSelect$1 as CreatableSelect, Divider, Drawer, Grid, GridItem, Heading, Image, Input$1 as Input, List, Loader, Menu, Modal, Popover, PopoverArrow, PopoverContent, Progress, Radio, RadioGroup, AutoSuggestSelect$1 as RefreshedAutoSuggestSelect, Button as RefreshedButtonInput, FormControl as RefreshedFormControl, Input as RefreshedInput, Select as RefreshedSelectInput, Select$1 as Select, SelectionCard, Spinner, Switch, Tabs, Text, Textarea, ThemeProvider, ToggleButtonGroup };
//# sourceMappingURL=index.esm.js.map
